// testerApp.js

// component to facilitate testing of shizzle contracts


import { Component } from 'react';

import { Button, Modal } from 'semantic-ui-react'

// mySleep is used to pace queries to WoC
import {
        getProviderContext,
//const {
        mySleep, persistUtxoUnFrozen, getFrozenUtxos, convertAddressToPKH,
//} from './core/commonFuncs.js';
//} from 'shizzle-core';

//import {
        openDB,
        deleteDB,

        buildOnAppend,
        buildShizzleLockingTx,

        queryFetchDecodeTx,
        findAllDomainsOfMine,

        allocateAvailableAddress,
        allocateAvailableRabin,
        getAvailableP2PKHsCount,
        getAvailableRabinsCount,

        checkIfDomainExpiredOrRenewable,
     //   registerDomainOfMine,

//} from './core/buildShizzle.js';
//} from 'shizzle-core';

//import {
      fetchUtxos,
//} from './core/providers.js';
//} from 'shizzle-core';


//import {
  analyzeDomainForClaiming,

  attemptToClaim,
    //expressClaimFunc,
    //buildPlusClaimFunc,
    claimAndPublishFunc,

  //registerBuiltNode,

  publishPost,
  findTipOfDomain,

  chooseOurTransientOutputForGuestPost,

  getRabinPrivs,
//} from './core/traversalFunctions.js';
//} from 'shizzle-core';


//import {
        HOLD_BACK_BLOCKHEIGHT_FOR_TESTING, MAX_PKHS, FOURTH_OF_YEAR_IN_BLOCKS,
//} from './core/harnessConstants.js';
//import {
        analyzeUTXOs, compareUtxosAgainstLocalCache,
      //} from './core/walletFuncs.js';
    //} from 'shizzle-core';

//import {  
          scanAllDomains,                             // Scan shizzle tree
                                                      // Generate and save (to IDB) a json array
                                                      // (with info for merkle leaves) to aid in migration
          publishMigrationDataFromIdbToBlockChain,    // publishes merkle leaves
          processMigrationDataFromIDB,                // builds a merkle tree
          readAndProcessMigrationDataFromBlockchain,   // builds a merkle tree
//} from "./core/migrationFuncs.js"
//} from 'shizzle-core';
//} = require( '../node_modules//shizzle-core/dist/shizzle-core.cjs');

        PROVIDER_PROPAGATION_DELAY_MS,
} from '../node_modules//shizzle-core/dist/es/shizzle-core.js'

import {
	getDecodedTx,
} from "./core/shizzleIDB.js"

import Toast from './toast.js'

import {
  bsv,
} from 'scryptlib' ;

import ProgressListModal from './progressListModal.js'
function shmalert(m) {
  //alert(a)
  console.error("testerApp ALERT: " + m)
}

function boldLog(message) {
  //FWIW: some css named colors:
  //      https://austingil.com/css-named-colors/
  const style = 'background-color: darkblue; color: white; font-style: italic; border: 5px solid darkorchid; font-size: 2em;'
  console.warn("%c" + message, style)
}
function darkLog(message) {
  //FWIW: some css named colors:
  //      https://austingil.com/css-named-colors/
  const style = 'background-color: darkblue; color: white; font-style: italic; border: 4px solid darkorchid; font-size: 1.5em;'
  console.warn("%c" + message, style)
}


const IDX_FOR_OLD_DOMAINS = 2


class TesterApp extends Component {
  constructor(props) {
    super(props);

    //const isMobile = this.props.isMobile;

    //this.props.bsvPriceUSD    // will be used to convert satoshi payments to dollars, cents (based on price for a given day)


    this.state = {
//      txid: '--> state.txid NOT YET SET <--',
      tipTxId: '--> state.tipTxId NOT YET SET <--',

      showQuickToast: false,
      toastText: '',
      toastDuration: 800,
      //suppressLoader: false,

      dummyVal: 0,

      newestSingleDomain: '',
      newestSingleTx: '',

      iteration: 0,
      baseContent: "Content for posting. Iteration: ",


      openTheProgressList: false,
      whichTestFuncForPLMToCall: null,
      nameOfTest: '',
      testCanceled: false,

      rootTxId: '',

      // both of these set in maybeInitializeFundingParams()
      // both cleared in closeWallet()
      privK: null,
      fundingAddress: null,

      freeRabinsCount: 0,
      freeP2PKHsCount: 0,

      walletInitialized: false,

      showBlockHeightTests: false,
      showMigrationOptions: false,


      finalQTxId: null,           // for testing of OLD domains: renewal, re-claim, purchases, etc
      finalPTxId: null,           // for testing PERIODICALS on OLD domains


      blockHeightForRenewing: 0,
      blockHeightForReclaiming: 0,

      priceToSell: 0,


      mostRecentDomain: '',
      numNodes: 0,

      showMerkleModal: false,
      merkleLeavesJSON: null,
      rawHexLeaves: null,
      merkleTreeArray: null,
    };

    this.plmResetFunction = () => {}

    // call this at various times, since we never get a trigger/event that the user
    // has logged in to make the bundle available
    // PERHAPS: would be better if parent supplied ALL funding props?
    this.maybeInitializeFundingParams   = this.maybeInitializeFundingParams.bind(this);
    this.closeWallet                    = this.closeWallet.bind(this);
    this.updateWalletSummary            = this.updateWalletSummary.bind(this);
    this.handleWalletClick              = this.handleWalletClick.bind(this);

    this.closeProgressList              = this.closeProgressList.bind(this);
    this.aTestWasCanceled               = this.aTestWasCanceled.bind(this);
    this.startATest                     = this.startATest.bind(this);
    this.allowSetStateToRipple          = this.allowSetStateToRipple.bind(this);

    this.kickOffPostToDomainWeAlreadyOwn= this.kickOffPostToDomainWeAlreadyOwn.bind(this);
    this.kickOffMultiStepGenTest        = this.kickOffMultiStepGenTest.bind(this);
    this.kickOffMultiStepPickTest       = this.kickOffMultiStepPickTest.bind(this);

    this.handleEraseEverythingClick     = this.handleEraseEverythingClick.bind(this);
    this.performFullReset               = this.performFullReset.bind(this);

    this.buildDialogForTesting          = this.buildDialogForTesting.bind(this);
    this.buildFirstBuilderPrep          = this.buildFirstBuilderPrep.bind(this);
    this.buildRootAppend                = this.buildRootAppend.bind(this);
    this.buildFanout                    = this.buildFanout.bind(this);
    this.buildLockingTx                 = this.buildLockingTx.bind(this);

    this.claimSingleDomain              = this.claimSingleDomain.bind(this);
    this.claimMultipleRandomDomains     = this.claimMultipleRandomDomains.bind(this);
    // random domains
    this.generateRandomDomainName           = this.generateRandomDomainName.bind(this);
    this.generateMultipleRandomDomainNames  = this.generateMultipleRandomDomainNames.bind(this);

    this.multiStepTest                  = this.multiStepTest.bind(this);

    this.claimAndPost                   = this.claimAndPost.bind(this);
    this.seekThenPost                   = this.seekThenPost.bind(this);
    this.seekThenGuestPost              = this.seekThenGuestPost.bind(this);

    this.cbSetupBuildLoop               = this.cbSetupBuildLoop.bind(this);
    this.cbProcessSearchResults         = this.cbProcessSearchResults.bind(this);

    this.analysisProgressFunc           = this.analysisProgressFunc.bind(this);
    this.analysisFinishCanceling        = this.analysisFinishCanceling.bind(this);
    this.analysisDone                   = this.analysisDone.bind(this);
    this.checkIfAnalysisCanceled        = this.checkIfAnalysisCanceled.bind(this);
    this.analysisJobWasCanceled         = this.analysisJobWasCanceled.bind(this);

    this.claimCallbackPrepProgress      = this.claimCallbackPrepProgress.bind(this);
    this.claimCallbackBroadcastProgress = this.claimCallbackBroadcastProgress.bind(this);
    this.claimFuncErrorCallback         = this.claimFuncErrorCallback.bind(this);


    this.contextFuncForInstaOffer       = this.contextFuncForInstaOffer.bind(this);
    this.contextFuncForRenewing         = this.contextFuncForRenewing.bind(this);
    this.contextFuncForSimpleBuild      = this.contextFuncForSimpleBuild.bind(this);

    this.contextFuncForPosting          = this.contextFuncForPosting.bind(this);

    this.milestoneFuncForPosting        = this.milestoneFuncForPosting.bind(this);    // and renewing
    //this.milestoneFuncForReclaiming     = this.milestoneFuncForReclaiming.bind(this);
    //this.milestoneFuncForRenewing
    this.errorFuncForPosting            = this.errorFuncForPosting.bind(this);        // and renewing

    this.showNormalTests                = this.showNormalTests.bind(this);
    this.showBlockHeightRelatedTests    = this.showBlockHeightRelatedTests.bind(this);
    this.showMigrationRelatedOptions    = this.showMigrationRelatedOptions.bind(this);

    this.scannerFeedback                = this.scannerFeedback.bind(this);
    this.publishMigrationNodes          = this.publishMigrationNodes.bind(this);
    this.readMigrationDataFromBlockchain= this.readMigrationDataFromBlockchain.bind(this);
    this.generateMerkleProof            = this.generateMerkleProof.bind(this);
    this.showMerkleTool                 = this.showMerkleTool.bind(this);
    this.closeMerkleTool                = this.closeMerkleTool.bind(this);
    this.processRegisteredNodes         = this.processRegisteredNodes.bind(this);

    this.scanOldDomains                 = this.scanOldDomains.bind(this);
    this.measureSlackOfOldDomains       = this.measureSlackOfOldDomains.bind(this);

    this.setupForBuildOfQuarterly       = this.setupForBuildOfQuarterly.bind(this);
    this.testRenewal                    = this.testRenewal.bind(this);
    this.testInstaOffer                 = this.testInstaOffer.bind(this);
    this.testBuildNextQuarterly         = this.testBuildNextQuarterly.bind(this);

    this.setupForBuildOfPeriodical      = this.setupForBuildOfPeriodical.bind(this);
    this.testBuildNextPeriodical        = this.testBuildNextPeriodical.bind(this);

    this.testReclaiming                 = this.testReclaiming.bind(this);
    this.testInstaBuy                   = this.testInstaBuy.bind(this);

    this.testPotentialOffer             = this.testPotentialOffer.bind(this);
    this.testPotentialBuy               = this.testPotentialBuy.bind(this);

    this.testAvatarPromotion            = this.testAvatarPromotion.bind(this);
  }

  async maybeInitializeFundingParams() {

    // we won't get values from parent UNTIL use opens wallet,
    // but, we won't get that event when it happens, so,
    // we check anytime user beings an operation, so we can run this that FIRST TIME
    if (typeof this.props.bundle == 'undefined' || this.props.bundle === null ) {
      console.warn("maybeInitializeFundingParams(): not right now")
      return
    }

    //PONDER: should we get priv key from App's getOfficialWalletRecord()
    //        IOW: from IDB?

    console.warn("testerApp: maybeInitializeFundingParams()  \n\n\n\n\n\n\n\n" )

    const pk = this.props.bundle.p
    const fundingPrivKey = bsv.PrivateKey.fromString(pk)
    const fundingAddress = fundingPrivKey.toAddress().toString()
    console.warn("maybeInitializeFundingParams(): fundingAddress: ", fundingAddress)
    //console.error("maybeInitializeFundingParams(): bundle.address: ", this.props.bundle.address)
    if ( fundingAddress !== this.props.bundle.address ) {
      console.error("trouble in testerApp's maybeInitializeFundingParam")
      alert("TROUBLE with wallet/funding")
      throw new Error("Wallet Error")
    }

    this.setState({privK: pk, fundingAddress: fundingAddress, walletInitialized: true})

    console.warn("maybeInitializeFundingParams(): initialize utxos...")
    const utxos = await fetchUtxos( getProviderContext(window.shizzleContext), fundingAddress, true, true, "sendLockingTx", window );

    console.warn("maybeInitializeFundingParams: utxos: ", utxos)


    // this should notice new sats/coins that come from OUTSIDE
    // this app (not as a result of anything happening here)
    // NOTE: this happens because we're feeding it a FRESH scan of UTXOs
    compareUtxosAgainstLocalCache(getProviderContext(window.shizzleContext), utxos)

    await this.allowSetStateToRipple()


    //NOTE: code below was COPIED from BitShizzleApp's getOfficialWalletRecord()
    //FIXME: consider just calling shizzle-core's getOfficialWalletRecord()


    // LOAD persisted FROZEN utxos
    const frozenUtxos = await getFrozenUtxos()

    console.warn("NOTE: we intend to mark " + frozenUtxos.length + " utxos as frozen...")
    console.log("       frozenUtxos: ", frozenUtxos)
    console.log("       fetched utxos: ", utxos)

    // Mod FRESH utxos with FROZEN
    for ( const freezie of frozenUtxos) {
      let found = false
      for ( const utxo of utxos ) {
        if ( utxo.txId === freezie.txId && utxo.outputIndex === freezie.outputIndex ) {
          utxo.FROZEN = true
          found = true
          console.warn("Found and handled one frozen utxo: " + freezie.txId + " : " + freezie.outputIndex)
          break
        }
      }
      if ( !found ) {
        console.warn("NOTE: We didn't find this IDB-cached frozen utxo in a fresh query: ", freezie)
        console.log("Most likely, it was spent/used it from another device/browser.")
        alert("NOTE: We didn't find this IDB-cached 'frozen' coin (of " + freezie.satoshis
            + " sats) in a fresh query of your wallet:\n\n"
            + freezie.txId + " : " + freezie.outputIndex
            + "\n\nMost likely, you spent/used it from another device/browser."
          )
        // REMOVE this mystery utxo from IDB-cached list of frozen coins
        // It must've been spent from another device/browser
        await persistUtxoUnFrozen(freezie)
      }
    }

//    console.log("    here are the utxos to add: ", utxos)
//    for ( const utxo of utxos) {
//      window.localUTXOs.push(utxo)
//      console.log("      added one...")
//    }

    console.warn("    NOW localUTXOs: ", getProviderContext(shizzleContext).localUTXOs)

    //FIXME: consider a TESTER APP IDB

  }  // maybeInitializeFundingParams()

  // show a 'toast' for a specified period
  quickToast(toastText, duration=2000, withoutLoader = false) {
      console.warn("quickToast()")
      this.setState({showQuickToast: true, toastText: toastText, toastDuration: duration, suppressLoader: withoutLoader})
      // once expired, quickToastDone() will be called
  }
  // called-back by toast, once it's expired
  quickToastDone(self) {
      self.setState({showQuickToast: false, suppressLoader: false})

      // now that it's expired, do NOTHING
  }

  handleEraseEverythingClick() {
    let okToErase = confirm("Are you sure you want to erase the ENTIRE IDB database (including your WALLET) ?")
    if ( okToErase ) {
      alert("Ok. We're about to delete your ENTIRE database (INCLUDING your wallet)!")
      this.setState({showResetModal: true})
    } else {
      alert("Fine. We won't do anything.")
    }
  }
  closeFullReset() {
    this.setState({showResetModal: false})
  }
  performFullReset() {
    try {
        // DON'T check with user - if they want to be careful about reloading.
        // RELOAD no-matter what (further down)
        window.onbeforeunload = null;

        deleteDB()
        alert("We've removed everything our site had saved to your browser. If you've got a backup, you should be able to restore it at any time. If you're done using BitShizzle, you should close this browser tab.")

        // closes modal
        this.closeFullReset()

        // reset citizenLevel back to 0
        //this.props.finishReset()

        // force reload - since we've wiped the IDB
        // (clear all state)
        window.location.reload()
    } catch (error) {
        console.error("Trouble performing full IndexedDB reset: ", error)
        alert("TESTER APP: We had a problem resetting/erasing your browser's Indexed DB")
    }
  }

  async buildFanout(dummy, dummy2, rootTxId = null) {

    await this.maybeInitializeFundingParams()

    try {

    if ( rootTxId === null ) {
      alert("NOTE: to be useful early on, you should be apps with a ?blockHeightOverride value deep in the past - well before CURRENT blockHeight: " + this.props.blockHeight)

      rootTxId = prompt("Please enter a ROOT Append txId from which to fan-out: ")
    }

    const db = await openDB();
    const rootAppendDtx = await queryFetchDecodeTx(window.shizzleContext, rootTxId, db, false)
console.error("type of rootAppendDtx: " + typeof rootAppendDtx)
    if ( typeof rootAppendDtx == 'number' || rootAppendDtx === null ) {
      alert("We had a problem finding that ROOT tx: " + rootTxId)
      return
    }

    console.warn("Here's the ROOT Append: ", rootAppendDtx)

    alert("We'll now allocate important keys for the genesis tx.")


    console.warn("We'll now allocate a builderPayout p2pkh, and rabinPKH (and vote) to be injected into the 'builderState'")

    const payoutAddressEntry = await allocateAvailableAddress(db)
    const rabinPkhEntry = await allocateAvailableRabin(db)
    const rabinPKH = rabinPkhEntry[0].pkh

    const payoutWIF = payoutAddressEntry[0].address
    const payoutPKH = convertAddressToPKH(payoutWIF)
    if ( payoutPKH === null || payoutPKH === -1 ) {
      console.error('testerAPP Failed converting address for genesis tx: ' + payoutWIF);

      alert("Something went wrong while trying to handle genesis Builder Payout address " + payoutWIF)
      return
    }

    console.warn("Will inject newly-allocated builder/payout P2PKH " + payoutPKH)
    console.warn("Will inject newly-allocated builder rabinPKH " + rabinPKH)

    alert("We'll now build and broadcast the GENESIS transaction - from which ALL ShizzleVerse domains will be derived.")


    const outIdx = 0                  // 0 for initial fan-out
    const initialBuilderVote = '00'   // NO
    const preClaimOrNo = 'n'          // nothing to claim on first fan-out
    const preClaimRabinPKH = ''       // not relevant
    const rootBlockHeight = 0         // special value to trigger 'same as previous blockHeight' handling
    const rootBalance = 0             // no need to put funds in genesis of shizzleTree
    const fundingPrivKey = this.state.privK

    const genesisTxId = await buildOnAppend( window.shizzleContext,
                                    rootAppendDtx.outputStates[outIdx], // decoded output from prev (ROOT) append
                                    rootTxId,			            // txId of ROOT append - upon which we're building
							                      outIdx,						        // output upon which we're building
                                    payoutPKH + rabinPKH + initialBuilderVote,  // builder state: payoutPKH + rabin + vote
                                    preClaimOrNo,				      // ’n’ for first fan-out
							                      preClaimRabinPKH,					// irrelevant for first fan-out. Set to ‘’
							                      rootBlockHeight,   				// use 0 to use the blockHeight from the previous (ROOT) append
                                    fundingPrivKey,		        // wallet privKey to FUND this tx
                                    rootBalance		            // 0 for first fan-out
                                    );

    console.warn("first/genesis fan-out tx: " + genesisTxId)

    const genesisDtx = await queryFetchDecodeTx(window.shizzleContext, genesisTxId, db, false)

    if ( genesisDtx === null ) {
      alert("We had a problem finding or decoding the GENESIS tx: " + genesisDtx)
      return
    }

    console.warn("Here's the decoded GENESIS tx (txId " + genesisTxId + "): ", genesisDtx)

    alert("We've built the GENESIS tx: " + genesisTxId +
          "\n\nSAVE this txId. THEN you should PROBABLY update the core lib (genesis module) with it, and the blockHeight: " + this.props.blockHeight)
    } finally {
      this.updateWalletSummary()
    }
  }

  // The sCrypt debugger may have trouble (a bug?) handling a txContext.inputIndex
  // that exceeds 1. If we need to DEBUG a failed transaction/spend, it may be
  // necessary to first 'move' an output/script to a tx where it sits at output #0.
  // This function helps accomplish that - here/currently for a Dialog.
  async buildDialogForTesting() {
    await this.maybeInitializeFundingParams()

    alert("The sCrypt debugger may have trouble (a bug?) handling a txContext.inputIndex that exceeds 1.\n\nIf we need to DEBUG a failed transaction/spend, it may be necessary to first 'move' an output/script to a tx where it sits at output #0.")
    try {
      const db = await openDB();

      const sourceTxId = prompt("enter a txId whose state you'd like to CLONE for a new Dialog tx: ")
      const theDb = await openDB();

      const dtx = await queryFetchDecodeTx(window.shizzleContext, sourceTxId, theDb, false)
      console.warn("FWIW: here's the tx we'll be cloning: ", dtx)

      const numOuts = dtx.outputStates.length
      console.warn("There are " + numOuts + " to choose from")
      const outIdx = prompt("enter the output# you'd like to use (max #" + (numOuts-1) + ")")
      const outInt = parseInt(outIdx, 10)
      const amount = prompt("Enter the AMOUNT (in sats) to place on the output")
      const contractAmount = parseInt( amount, 10)

      const initStateData = dtx.outputStates[ outInt ].stateHex

      console.warn("We'll now build a Dialog tx from a CLONE of output # " + outIdx + " of tx " + sourceTxId)
      console.log("And we'll place " + amount + " sats on it")
      console.log("We'll place " + contractAmount + " sats on it")
      console.log("  and here's the state we'll copy: " + initStateData)

      console.warn("LASTLY, it may be necessary to FIND a way to inject INPUT parameters: ",
                  dtx.outputStates[ outInt ].inputParams
      )
      alert("Ready? You'll want to inspect the INPUT params (.inputParams) displayed in the console")

      const extraParams = {
        initStateData: initStateData,
        contractAmount: contractAmount
      }

      const txid = await this.buildLockingTx('Dialog', /*db,*/ extraParams) //also line 611

      console.warn("tester: we've built a dialog tx: " + txid)
      if ( txid !== null ) {
        const decodedDialogTx = await queryFetchDecodeTx(window.shizzleContext, txid, db, false)
        
        console.warn("Here's our DECODED dialog tx: ", decodedDialogTx)
      }
    } finally {
      this.updateWalletSummary()
    }
  }

  async buildRootAppend() {

    await this.maybeInitializeFundingParams()

    try {
      const db = await openDB();
      if ( !confirm("Before proceeding, consider that you should PROBABLY perform a FULL RESET of your IDB (from your wallet), generate and SAVE a new wallet, and THEN return here.\n\nShall we proceed?") ) {
        return
      }

      alert("This operation will allocate keys from your wallet - and use them to define those of the " +
            MAX_PKHS + " initial/hardcoded 'Builders' of the ShizzleVerse. They'll be embedded within the " +
            "ROOT of the ShizzleVerse name tree, and disseminated throughout ALL domains as they are claimed by users." +
            "\n\nPayout keys can be used to collect/spend builderPayouts (fees) from user domains." +
            "\n\nBuilder rabin keys can be used to broadcast Emergency Builder Fee Reduction Authorizations (EBFRAs)." +
            "\n\nEBFRAs can be used by any/all DESCENDANT domains of that builder - to lower their builder fees." +
            "\n\nOutside of TESTNET/testing, this operation should only be performed ONCE on MAINNET.")

      alert("WARNING: you'll want to backup your wallet IMMEDIATELY. " +
            "\n\nThe keys we're about to allocate (and embed within the ROOT transaction) will be relevant " +
            "for the duration of the ShizzleVerse instance you're about to deploy.")

      let builderState = []
      // allocate p2pkh, and rabin entries from the wallet
      for ( let i = 0; i < MAX_PKHS; ++i ) {
        const payoutAddressEntry = await allocateAvailableAddress(db)
        const rabinPkhEntry = await allocateAvailableRabin(db)

        const payoutWIF = payoutAddressEntry[0].address
        const payoutPKH = convertAddressToPKH(payoutWIF)
        if ( payoutPKH === null || payoutPKH === -1 ) {
            console.error('testerAPP: Failed converting payout address for root tx: ' + payoutWIF);

            alert("Something went wrong while trying to handle root Builder Payout address " + payoutWIF)
            return
        }

        console.warn("We're about to use an address: ", payoutPKH)
        console.warn("We're about to use a rabinPkhEntry: ", rabinPkhEntry)

        builderState.push ( {
                              p2PKH: payoutPKH,
                              rabinPKH: rabinPkhEntry[0].pkh,
                              vote: '00'
                            } )
      }
      const extraParams = {
        // we don't NEED to pass the genesisBlockHeight, nor the currentBlockHeight
        // They'll get filled-in with random values if we don't provide them
        //genesisBlockHeight: 1,
        //currentBlockHeight: 2,
        builderStateList:  builderState,// .p2PKH, .rabinPKH, feeReduction .vote ('00', or '11')
      }

      const txid = await this.buildLockingTx('Append', /*db,*/ extraParams, this.state.privK) //also line 611

      if ( txid !== null ) {
        const decodedRootAppendTx = await queryFetchDecodeTx(window.shizzleContext, txid, db, false)

        console.warn("txId for the new ROOT Append: " + txid)
        console.warn("Here's the decoded ROOT Append: ", decodedRootAppendTx)

        alert("We've SUCCESSFULLY built a ROOT append. TxId: " + txid +
              "\n\nSAVE this txId - so you can next generate a Genesis Append (first fanout) tx"
        )
      } else {
        alert("We had trouble building a ROOT append")
      }

    } finally {
      this.updateWalletSummary()
    }
  }

  async buildFirstBuilderPrep() {

    await this.maybeInitializeFundingParams()

    try {
    const db = await openDB();
    const txid = await this.buildLockingTx('BuilderPrep' /*, db*/)

    if ( txid !== null ) {
      console.error("Built builderPrep locking txId: ", txid)
      const decodedBuilderPrepLockingTx = await queryFetchDecodeTx(window.shizzleContext, txid, db, false)

      console.warn("Here's the resultant builderPrep: ", decodedBuilderPrepLockingTx)
      alert("SUCCESSFULLY built a builderPrep. TxId: " + txid)
    } else {
      alert("We had trouble building a builderPrep")
    }

    } finally {
      this.updateWalletSummary()
    }
  }

  async buildLockingTx(contractType, /*db,*/ extraParams = null) {


console.warn("BEFORE calling buildShizzleLockingTx()... window.shizzleContext: ", window.shizzleContext)
console.warn("BEFORE calling buildShizzleLockingTx()... providerContext: ", getProviderContext(window.shizzleContext))

    let txid
    try {
      //const contractType =
      //                      'BuilderPrep'
      //                or    'Append'

      txid = await buildShizzleLockingTx(window.shizzleContext, /*db,*/ contractType, this.state.privK, /*(this.props.bundle.p,*/ extraParams ); //also line 555

    } catch (error) {
      console.log("TESTER App: buildLockingTx(): Failed building a locking tx of type "
                + contractType);
      console.error("ERROR: ", error);

      return null;
    }

    console.log("buildLockingTx(): BUILT txId: " + txid);

    this.setState({rootTxId: txid});

    return txid
  }

  cbSetupBuildLoop(latestTxId, latestTx, nextOutIndex) {
    console.warn("cbSetupBuildLoop()...")

    //COPIED from claimer


    // INITIAL loop setup

    // Set state of all important parameters
    // in preparation for looping

    // This is called at the conclusion of the asset SEARCH/analysis

    // The actual loop (below), is started by the user clicking CLAIM

    // SIMILAR work is also done after each iteration (in toastLoopPropagateDone())


    const dtxString = JSON.stringify( latestTx );

    console.log("cbSetupBuildLoop(): loopTxId: ", latestTxId)
    console.log("cbSetupBuildLoop(): loopTxStr: ", dtxString)
    console.log("cbSetupBuildLoop(): loopTxLimbName: ", latestTx.limbName)
    console.log("cbSetupBuildLoop(): loopNextOutIdx: ", nextOutIndex)

    this.setState({
        furthestTxId: latestTxId,       //loopTxId:       latestTxId,
        furthestTxDecoded: dtxString,   //loopTxStr:      dtxString,
        reachedLimb: latestTx.limbName, //loopTxLimbName: latestTx.limbName,
        outputIndex: nextOutIndex       //loopNextOutIdx: nextOutIndex        // which output to build on
    })
    //FIXME: consider setting state .loopParamsSet: true  - to enable CLAIM button
    //       probably not necessary
  }

  async cbProcessSearchResults(reachedLimb, furthestTxId, found, owned, extraWords, outputIndex, buildingOnModeP = false) {
    console.warn("cbProcessSearchResults()...")

    //COPIED FROM CLAIMER


    const db = await openDB()
    console.log("pSR(): will query tx " + furthestTxId + "...")

    // Maybe we don't need to query the provider this time
    // We've probably done it very, very recently
    let limb = ''
    const dtx = await getDecodedTx(db, furthestTxId)
    if ( dtx !== null ) {
      console.warn("cbPSR():  dtx not null, so, will set state")
      //console.error("REMOVE THIS: TESTER APP cbProcessSearchResults()")

      // Update state with 'results'

      let expired = false
      let newOwnerCount = 1
      if ( owned ) {
        console.log("This asset is already OWNED, but current height is " + this.props.blockHeight
                    + ", and we should check if the asset has expired. ", dtx)
        if ( dtx.outputStates[0].renewalDeadlineInt < this.props.blockHeight ) {
          console.warn("This asset has EXPIRED. The user could re-claim it.")
          expired = true
          newOwnerCount = dtx.outputStates[0].ownerCount + 1
        } else {
          console.log("Assset is already owned, and NOT yet expired.")
        }
      }

      var txString = JSON.stringify( dtx );
      this.setState({ furthestTxId: furthestTxId,              //FIXME: rename this
                      furthestTxDecoded: txString,             //FIXME: rename this
                      outputIndex: outputIndex,                //FIXME: rename this. Too generic
                      found: found,
                      owned: owned,
                      expired: expired,
                      //registeredToUs: registeredToUs,
                      //weSubscribeToThis: weSubscribeToThis,
                      reachedLimb: reachedLimb,
                      extraVerbage: extraWords,
                      buildingOnModeP: buildingOnModeP,

                      newOwnerCount: newOwnerCount,
                  });

    } else {
      console.error("Where's the decodexTx string?")
      //alert("ERROR: Not sure why we have NO tx to mention")
      throw new Error("IMPLEMENT return results:  hmm. available for claiming?")
    }
  } //cbProcessSearchResults

  claimCallbackPrepProgress(numTxs, numToBuild, preClaimOrNo, preClaimRabinPKH) {
    //update toast with progress
    this.setState({claimOperation: "build", claimProgress: <>{numTxs+1}/{numToBuild}</>})
    if ( preClaimOrNo === 'y' ) {
      console.warn("Now that we're done BUILDING transactions to claim, let's take note of the key we used to actually claim this domain: ", preClaimRabinPKH)
      this.setState({keyUsedToClaim: preClaimRabinPKH,
                      pToEnc: '', qToEnc: ''
                  })
    }
  }

  claimCallbackBroadcastProgress(j, numTxs) {
    this.setState({claimOperation: "broadcast", claimProgress: <>{j+1}/{numTxs}</>})
  }

  claimFuncErrorCallback(errno, target = null, error = null, payoutWIF = null,
                          errorContext = null) {
    console.error("tester claimFuncErrorCallback() errno: ", errno)
    console.error("tester claimFuncErrorCallback() target: ", target)
    console.error("tester claimFuncErrorCallback() error ", error)
    console.error("tester claimFuncErrorCallback() payoutWIF: ", payoutWIF)
    console.error("tester claimFuncErrorCallback() errorContext: ", errorContext)
    switch(errno) {
        case 1:
            console.error("attemptToClaim error 1: trouble finding best UTXO. FIXME: about to throw. target: " + target)
            throw new Error("44821: FAILED to find the BEST UTXO")
            break;
        case 2:
            console.warn("attemptToClaim error 2: trouble querying for funds? target: " + target)
            alert("CLAIMER had trouble querying for the funds in your wallet. Please try again. If that fails, you may need to wait for the provider to recover.")
            break;
        case 3:
            console.warn("attemptToClaim error 3: need more builder payout keys? target: " + target)
            alert("ERROR: Your wallet may have run-out of available (un-allocated) Builder Payout keys. Check your wallet. ABORTING")
            //FIXME: resetSearch()?
            break;
        case 4:
            console.warn("attemptToClaim error 4: handling builder payout key. target: " + target + ". payout: " + payoutWIF)
            console.log('Failed converting address in Claimer::expressClaim()');

            alert("Something went wrong while trying to handle Builder Payout address " + payoutWIF + ". Please report this.")
            //FIXME: resetSearch()?
            break;
        case 5:
            console.warn("attemptToClaim error 5: insufficient Builder keys? target: " + target)
            alert("ERROR: Your wallet may have run-out of available (un-allocated) Builder keys. Check your wallet. ABORTING")
            //FIXME: resetSearch()?
            break;
        case 6:
            console.warn("attemptToClaim error 6: not enough publisher keys. target: " + target)
            alert("ERROR: Your wallet may have run-out of available (un-allocated) Publisher keys. Check your wallet. ABORTING")
            //FIXME: resetSearch()?
            break;
        case 7:
            console.warn('attemptToClaim error 7: Failed in expressClaim() target: ' + target);
            console.log('Failed in expressClaim()()');
            //console.log('Failed on network: ' + NETWORK)
            console.error("stack: " + error.stack);

            alert("Something went wrong while we were trying to claim that domain: " + target
                + ". Maybe something changed since we last checked, OR you've entered an invalid character. Please try again.")
            //FIXME: resetSearch()
            break;
        case 8:
            console.warn("attemptToClaim error 8: de-coding.  target: " + target)
            alert("whoops. a null rawTx? DE-CODING ERROR")

            //FIXME: showBuildingToast?
            //FIXME: resetSearch()?
            break;
        case 100:
            console.error("attemptToClaim broadcast error 100: unexpected txId. target: " + target)
            console.error("attemptToClaim broadcast error context: ", errorContext)
            alert("FIXME: attemptToClaim error: unexpected txId. malleation? coding error?\n\n\nMUST handle, DISPLAY more ERROR CONTEXT")
            break;

        case 201:
            console.error("attemptToClaim BPCA error 201: trouble allocating address. target: " + target)
            alert("BPCA error 201")
            break;
        case 202:
            console.error("attemptToClaim BPCA error 202: trouble allocating payout PKH. target: " + target + ", payoutWIF: ", payoutWIF)
            alert("BPCA error 202")
            break;
        case 203:
            console.error("attemptToClaim BPCA error 203: trouble allocating builder payout. target: " + target)
            alert("BPCA error 203")
            break;
        case 204:
            console.error("attemptToClaim BPCA error 204: trouble allocating publisher key. target: " + target)
            alert("BPCA error 204")
            break;
        case 205:
            console.error("attemptToClaim BPCA error 205: trouble building on append. target: " + target)
            console.error("stack: " + error.stack);
            alert("BPCA error")
            break;

        case 301:
            console.error("attemptToClaim jCAP error 301: not enough publisher keys. target: " + target)
            alert("ERROR: Your wallet may have run-out of available (un-allocated) Publisher keys. Check your wallet. ABORTING")
            break;
        case 302:
            console.error("attemptToClaim jCAP error 302: failed building (or registering?) target: " + target)
            //console.log('Failed on network: ' + NETWORK)
            console.error("stack: " + error.stack);
            //showError(error);    // needed?
            alert("Something went wrong while attempting to just claim an asset, and broadcast it")
            break;
        case 303:
            console.error("can't claim a domain that's not for sale: " + target)
            break;
        case 304:
            console.error("trouble tracking-down rabin priv keys for pkh " + errorContext.pkh + " - for " + target)
            break;

        default:
            console.error("attemptToClaim: Please report INVALID errno returned by claim func: " + errno + "  target: " + target)
            alert("Please report INVALID errno returned from claim func: " + errno)
            //FIXME: resetSearch()?
            break;
    }
    this.setState({showBuildingToast: false})
  }

 /*
      console.warn("BTW: this.state.nameToClaim: ", this.state.nameToClaim)
      console.warn("BTW: this.props.blockHeight: ", this.props.blockHeight)
  
      console.warn("BTW: this.state.loopTxId: ", this.state.loopTxId)
      console.warn("BTW: this.state.loopTxStr: ", this.state.loopTxStr)
      console.warn("BTW: this.state.loopTxLimbName: ", this.state.loopTxLimbName)
      console.warn("BTW: this.state.loopNextOutIdx: ", this.state.loopNextOutIdx)
      console.warn("BTW: this.state.nameToClaim: ", this.state.nameToClaim)
      console.warn("BTW: this.state.newOwnerCount: ", this.state.newOwnerCount + " <------ important")
  
      console.warn("BTW: this.state.owned: ", this.state.owned + "   <----- note")
      console.warn("BTW: this.state.expired: ", this.state.expired)
      console.warn("BTW: this.state.buildingOnModeP: ", this.state.buildingOnModeP)
  
      console.warn("BTW: this.state.furthestTxDecoded: ", this.state.furthestTxDecoded)
      console.warn("BTW: this.state.outputIndex: ", this.state.outputIndex)
*/

  analysisProgressFunc(report) {
    console.warn("logReportOfProgress():  " + report)
  }
  analysisFinishCanceling(parent) {
    console.warn("Tester APP: finishFinishCanceling()...")
  }

  analysisDone() {
    console.warn("Tester APP: analysisDone()")
  }

  checkIfAnalysisCanceled() {
    console.warn("checkIfAnalysisCanceled()...")

    //FIXME: setState(), so cbJobWasCanceled can check?
    return false
  }
  analysisJobWasCanceled(parent, progressFunc, finishCanceling) {
    console.warn("cbJobWasCanceled()  Will check...")

    const canceled = false
    if ( canceled ) {
      progressFunc("SEARCH WAS CANCELED at some point.")
      finishCanceling(parent)

      /*
      this.setState({
          furthestTx: null,
          decodedTx: '',
          found: false,   // implies should build further
          owned: false,
          reachedLimb: '',
          extraVerbage: 'canceled'});
      */
      return true
    } else {
        return false
    }
  }

  closeProgressList() {
    console.log("closeProgressList() called")
    this.setState({openTheProgressList: false})

    // clear the CONTENT of the progressListModal - for next time
    this.plmResetFunction()
  }
  aTestWasCanceled() {
    console.warn("The test was just canceled. We were notified by PLM")
    this.setState({testCanceled: true})
  }
  async startATest(nameOfTest, funcForProgressListToCall) {

    await this.maybeInitializeFundingParams()

    try {
      alert("testerApp: startATest(): will open PLM, then start a test named: " + nameOfTest)
      this.setState({ openTheProgressList: true,
                      nameOfTest: nameOfTest,
                      whichTestFuncForPLMToCall: funcForProgressListToCall})
    } finally {
      this.updateWalletSummary()
    }
  }

  async allowSetStateToRipple() {

    const initialValue = this.state.dummyVal

    this.setState({dummyVal: initialValue + 1})

    do {
      // This worked with 50
      // 10 should also work
      await mySleep(10, "sleeping to allow analysis state to ripple (to value " + (initialValue + 1) + ")...")
    } while ( this.state.dummyVal === initialValue)

    //console.error("\n\n\ndummyVal has rippled to " + this.state.dummyVal + "\n\n\n")
  }

  contextFuncForPosting() {
    console.warn("TesterApp contextFunc():")
    return {
      inviteToDialog:                 false,
      dialogTxId:                     '',
      latestTxId:                     this.state.newestSingleTx,             // <----- what we're about to build on
      dialogDtx:                      null,
      dtx:                            this.state.newestDtx,                    // <----- what we're about to build on
      requestedDomain:                this.state.newestSingleDomain,        // <----- domain we're posting ON
      ourIdentity:                    this.state.newestSingleDomain,            // <----- domain we're posting from
      purchaseThisDomain:             false, 
      buildAnnouncement:              false,
      addPhotoToPost:                 false,
      photoBlob:                      null,
      addVideoToPost:                 false,
      videoToAdd:                     null,
      content:                        this.state.baseContent + this.state.iteration,                // <-----
//FIXME: app should allocate this - if we want to test anything that later uses encryption
transientCommsKey:                  '000000000000000000000000000000000000000000000000000000000000000000',//transientCommsKeyBytes,
      guestPostPriceForThisIdentity:  100,                    // 100000000   <---- should match actual
      encryptSelfPost:                false,                              // undefined? <--- ???????
      furthestQuarterlyStats:         {renewable: false}, // ??? IMPORTANT???
      onOurCurrentIdentity:           true,                   // <-----
      domainPriceInSats:              10,                     // <----- should match actual. but what?
      weHaveATransient:               false,                  // <===== DEPENDS

      propsBundlePwd:                 this.props.bundle.pwd,             /// SECRET wallet pwd
      propsBundleP:                   this.state.privK,       /// PRIVATE WIF cUmH...

//FIXME: we're duplicating state.   D.on't R.epeat Y.ourself
      propsBundleAddress:             this.state.fundingAddress,         /// wallet address moM78...

      propsBlockHeight:               this.props.blockHeight, ///  
    }
  }

  contextFuncForRenewing() {
    console.warn("TesterApp contextFunc() - for renewing:")
    return {
      inviteToDialog:                 false,
      dialogTxId:                     '',
      latestTxId:                     this.state.newestSingleTx,             // <----- what we're about to build on
      dialogDtx:                      null,
      dtx:                            this.state.newestDtx,                    // <----- what we're about to build on
      requestedDomain:                this.state.newestSingleDomain,        // <----- domain we're posting ON
      ourIdentity:                    this.state.newestSingleDomain,            // <----- domain we're posting from
      purchaseThisDomain:             false, 
      buildAnnouncement:              false,
      addPhotoToPost:                 false,
      photoBlob:                      null,
      addVideoToPost:                 false,
      videoToAdd:                     null,
      content:                        this.state.baseContent + this.state.iteration,                // <-----
//FIXME: app should allocate this - if we want to test anything that later uses encryption
transientCommsKey:                  '000000000000000000000000000000000000000000000000000000000000000000',//transientCommsKeyBytes,
      guestPostPriceForThisIdentity:  100,                    // 100000000   <---- should match actual
      encryptSelfPost:                false,                              // undefined? <--- ???????
  furthestQuarterlyStats:         this.state.qStats, // ??? IMPORTANT???
      onOurCurrentIdentity:           true,                   // <-----
  domainPriceInSats:              0,                     // <----- should match actual. but what?  BTW: MAYBE must be 0 if what?
      weHaveATransient:               false,                  // <===== DEPENDS

      propsBundlePwd:                 this.props.bundle.pwd,             /// SECRET wallet pwd
      propsBundleP:                   this.state.privK,       /// PRIVATE WIF cUmH...

//FIXME: we're duplicating state.   D.on't R.epeat Y.ourself
      propsBundleAddress:             this.state.fundingAddress,         /// wallet address moM78...

  propsBlockHeight:               this.state.blockHeightForQ, ///  
    }
  }

  contextFuncForSimpleBuild() {
    console.warn("TesterApp contextFunc() - for simple build of Q:")
    return {
      inviteToDialog:                 false,
      dialogTxId:                     '',
      latestTxId:                     this.state.newestSingleTx,             // <----- what we're about to build on
      dialogDtx:                      null,
      dtx:                            this.state.newestDtx,                    // <----- what we're about to build on
      requestedDomain:                this.state.newestSingleDomain,        // <----- domain we're posting ON
      ourIdentity:                    this.state.newestSingleDomain,            // <----- domain we're posting from
      purchaseThisDomain:             false, 
      buildAnnouncement:              false,
      addPhotoToPost:                 false,
      photoBlob:                      null,
      addVideoToPost:                 false,
      videoToAdd:                     null,
      content:                        this.state.baseContent + this.state.iteration,                // <-----
//FIXME: app should allocate this - if we want to test anything that later uses encryption
transientCommsKey:                  '000000000000000000000000000000000000000000000000000000000000000000',//transientCommsKeyBytes,
      guestPostPriceForThisIdentity:  100,                    // 100000000   <---- should match actual
      encryptSelfPost:                false,                              // undefined? <--- ???????
  furthestQuarterlyStats:         this.state.qStats, // ??? IMPORTANT???
      onOurCurrentIdentity:           true,                   // <-----
  domainPriceInSats:              0,                     // <----- should match actual. but what?  BTW: MAYBE must be 0 if what?
      weHaveATransient:               false,                  // <===== DEPENDS

      propsBundlePwd:                 this.props.bundle.pwd,             /// SECRET wallet pwd
      propsBundleP:                   this.state.privK,       /// PRIVATE WIF cUmH...

//FIXME: we're duplicating state.   D.on't R.epeat Y.ourself
      propsBundleAddress:             this.state.fundingAddress,         /// wallet address moM78...

  propsBlockHeight:               this.state.blockHeightForQ, ///  
    }
  }

  contextFuncForInstaOffer() {  // could be called by publishPost()
    console.warn("TesterApp contextFunc() - for insta-OFFER:")
    return {
      inviteToDialog:                 false,
      dialogTxId:                     '',
      latestTxId:                     this.state.newestSingleTx,             // <----- what we're about to build on
      dialogDtx:                      null,
      dtx:                            this.state.newestDtx,                    // <----- what we're about to build on
      requestedDomain:                this.state.newestSingleDomain,        // <----- domain we're posting ON
      ourIdentity:                    this.state.newestSingleDomain,            // <----- domain we're posting from
      purchaseThisDomain:             false, 
      buildAnnouncement:              false,
      addPhotoToPost:                 false,
      photoBlob:                      null,
      addVideoToPost:                 false,
      videoToAdd:                     null,
      content:                        this.state.baseContent + this.state.iteration,                // <-----
//FIXME: app should allocate this - if we want to test anything that later uses encryption
transientCommsKey:                  '000000000000000000000000000000000000000000000000000000000000000000',//transientCommsKeyBytes,
      guestPostPriceForThisIdentity:  100,                    // 100000000   <---- should match actual
      encryptSelfPost:                false,                              // undefined? <--- ???????
  furthestQuarterlyStats:         this.state.qStats, // ??? IMPORTANT???
      onOurCurrentIdentity:           true,                   // <-----
  domainPriceInSats:              this.state.priceToSell,              ///////////  THIS is the key differentiator for insta-OFFER  ///////////
      weHaveATransient:               false,                  // <===== DEPENDS

      propsBundlePwd:                 this.props.bundle.pwd,             /// SECRET wallet pwd
      propsBundleP:                   this.state.privK,       /// PRIVATE WIF cUmH...

//FIXME: we're duplicating state.   D.on't R.epeat Y.ourself
      propsBundleAddress:             this.state.fundingAddress,         /// wallet address moM78...

  propsBlockHeight:               this.state.blockHeightForQ, ///  
    }
  }

  errorFuncForPosting(errno, context) {
    console.warn("errorFuncForPosting(): errno: ", errno, " context: ", context)
  }

  async milestoneFuncForPosting(mNum, mContext) {
//FIXME: something like this could be HELPFUL, within the context, when debugging.
//       BUT, be sure we understand if it's the HOST, or GUEST
//    console.warn("milestoneFunc(): num: ", mNum, " (domain: " + nameToClaim + ")  context:", mContext)
//    shmalert("milestone function (" + mNum + ") (domain: " + nameToClaim + "). Check the console")

    if ( mNum === 1 ) {
      console.warn("milestone 1 on iteration: " + this.state.iteration)

      const troubledTxId = mContext.stateProps.inviteToDialog ? mContext.stateProps.dialogTxId : mContext.stateProps.latestTxId
      console.warn(" since we had trouble building on txId " + troubledTxId + " (no buildable outputs)")
      console.warn("   we'll use alternative txId: " + mContext.latestTxId)

      alert("milestone 1 - evasive maneuvers. Will build on a DIFFERENT tx.\n\nExpand the context in 5 seconds...")

if ( confirm("Want to EXIT - instead of continuing with this EVASIVE MANEUVER?") ) {
  await mySleep(2000, "WAIT")
  if ( confirm("REALLY? You want to EXIT???? (hit CANCEL to continue)") ) {
    await mySleep(1000, "exit?")
    if ( !confirm("Last chance: RETURN to execution?") ) {
      throw new Error("bleh")
    }
  }
}

      // call this function again - AFTER setting state with
      // a DIFFERENT latest tx upon which we'll build
      // NOTE that we'll pass-along any final-processing function
      this.setState({ newestSingleTx: mContext.latestTxId,
                      newestDtx:      mContext.dtx
                    })

      //NOTE: we NEED to keep this entirely serial, on the
      //        MAIN 'thread'. We can't call publishPost()
      //        on some secondary thread after setState() ripples,
      //        because we have a LOOP which is ready to run
      //        the next iteration AT THE SAME TIME.
      //      This is UNLIKE surfer's handling of milestone 1,
      //        where we can be sure there is no tx
      //        being built in parallel.
      await this.allowSetStateToRipple()

      await publishPost(window.shizzleContext,
                        mContext.p1, // specialMode
                        mContext.p2, // isAGuestPost
                        mContext.p3, // latestGuestTxIdOnWhichToBuild
                        mContext.p4, // guestDtx
                        mContext.p5, // guestBestOutputNum
                        mContext.p6, // guestOutputStateOnWhichToBuild,
                        mContext.finalProc,

                        this.contextFuncForPosting,
                        this.milestoneFuncForPosting,
                        this.errorFuncForPosting
                      );

      shmalert("milestone 1 DONE - note the console")
    } else if ( mNum === 2 ) {
      console.warn("milestone 2")
    } if ( mNum === 3 ) {
      console.warn("milestone 3. we've got a new txId: " + mContext.newTxId)
      console.warn("milestone 3. iteration: " + this.state.iteration)
      console.warn("    [note: in the NEXT milestone it'll be known as mContext.ourDtxLatestId (decoded as .ourDtx)]")
    } else if ( mNum === 4 ) {
      console.warn("milestone 4. context: ", mContext)
      console.warn("milestone 4. iteration: " + this.state.iteration)
      console.error("milestone 4. PATH: ", mContext.ourDtx.address)
      console.warn("  context.stateProps: ", mContext.stateProps)
      console.warn("  context.ourDtxLatestId: "   + mContext.ourDtxLatestId + " <------- txId")
      console.warn("  context.ourDtx+: "           , mContext.ourDtx,  " <======= decoded tx")
      console.warn("  context.ourDtx: "           , mContext.ourDtx)
      console.warn("  context.bestOutputType: "   + mContext.bestOutputType)
      console.warn("  context.weHaveATransient: " + mContext.weHaveATransient)

      console.warn("  AND priceInSats: "+ mContext.ourDtx.priceInSats )

      // Update state to reflect the latest post
      // This sets us up for the next iteration - to be able to easily post again
      this.setState({ newestSingleTx: mContext.ourDtxLatestId,
                      //newestSingleDomain: nameToClaim, // unchanged
                      newestDtx:      mContext.ourDtx,
                      iteration: this.state.iteration + 1
                    })
      await this.allowSetStateToRipple()

      shmalert("milestone 4. Read context in console.")
    } else if ( mNum === 100 ) {

      console.warn("milestone 100. context: ", mContext)
      console.warn(" context.encrypteSelfPost: " + mContext.encryptSelfPost)
      console.warn(" context.dtx: ", mContext.dtx)
      console.warn(" context.contentAsHexString: " + mContext.contentAsHexString)
      console.warn(" context.isHex: " + mContext.isHex)

      shmalert("milestone 100: We're demanding NO encryption right now.  <------")
      // yesEncrypt, dtx, content, isActuallyHex = false) {

      console.log("Will use the CLEAR text (in hex)")
      let contentToSend
      if ( mContext.isHex ) {
          contentToSend = mContext.contentAsHexString
      } else {
          // convert content to a HEX string
          contentToSend = Buffer.from(mContext.contentAsHexString, 'utf8').toString('hex')
      }

      console.log("milestone 100 will return maybeEncryptedContent of " + contentToSend)

      shmalert("milestone 100 returning")
      return contentToSend
    }
  } //milestoneFuncForPosting

    //const target = 'rararara'     // green fields - triggers expressClaimFunc()
    //const target = 'rararara'   exists. not expired. ABORT
    //const target = 'rararar'   //jCap() 1
    // NOTE: jCAP() 2 triggered by EXPIRED scenario
    //const target = 'raraf'  //bPCA()

  async claimSingleDomain(dummy, dummy2, domainToClaim = null, useOldBlockHeights = false) {

    await this.maybeInitializeFundingParams()

    try {
    let i = 0
    let nameToClaim
    do {
      nameToClaim = domainToClaim ? domainToClaim : prompt("Please enter a VALID domain to claim:", "someDomain")
      ++i
    } while ( i < 3 && (nameToClaim === null || nameToClaim.length < 1 || nameToClaim.length > 38) )
    if ( i === 3 ) {
      console.error("claimSingleDomain(): GIVING UP on user")
      return
    }

    // use 'old' ?
    nameToClaim = useOldBlockHeights ?
                      'old' + nameToClaim.toLowerCase()
                    :
                      nameToClaim.toLowerCase()

    if ( useOldBlockHeights && !HOLD_BACK_BLOCKHEIGHT_FOR_TESTING ) {
      alert("Since you're looking to operate with OLD blockHeights, you need to set HOLD_BACK_BLOCKHEIGHT_FOR_TEST to true." +
            "\n\nPlease see file harnessConstants.js"
      )

      return
    } else {
      alert("useOldBlockHeights: " + useOldBlockHeights)
      alert("You've got the correct value for 'HOLD_BACK_BLOCKHEIGHT_FOR_TESTING' - set to " + HOLD_BACK_BLOCKHEIGHT_FOR_TESTING)
    }

    if ( useOldBlockHeights ) {
      alert("NOTE: domain will be claimed - but prepended with 'OLD'")
    }



    //let name = prompt("Please enter the domain to post on:");
    alert("Will claim " + nameToClaim)

    console.warn("Tester APP: claim a single domain: ", nameToClaim)

    await analyzeDomainForClaiming( window.shizzleContext,
                                    this,
                                    this.analysisProgressFunc,
                                    this.analysisFinishCanceling,
                                    this.analysisDone,

                                    nameToClaim,

                                    this.props.blockHeight,

                                    this.checkIfAnalysisCanceled,
                                    this.analysisJobWasCanceled,
                                    this.cbProcessSearchResults, // decodes, examines final tx for expired, and determines newOwnerCount
                                    this.cbSetupBuildLoop        //used only by express/loop approach
                                  )

    //checksucessfail?
    shmalert("claimSingleDomain(): analysis complete. Will now attemptToClaim() " + nameToClaim)

// NOTE: processSearchResults fills-out these params - but they first need to ripple...

    await this.allowSetStateToRipple()

    console.warn("TESTER: claimSingleDomain(): dummy setState has rippled. will now ATTEMPTtoClaim()...")
    const {keyUsedToClaim, newTx} = await attemptToClaim(window.shizzleContext,
                          nameToClaim,

                          this.state.found,

                          this.props.blockHeight,
                          this.state.furthestTxId,      //loopTxId,
                          this.state.furthestTxDecoded, //loopTxStr,     //Used by expressClaimFunc
                          this.state.reachedLimb,       //loopTxLimbName,
                          this.state.outputIndex,       //loopNextOutIdx,

                          this.state.newOwnerCount,
                          this.state.owned,
                          this.state.expired,
                          this.state.buildingOnModeP,

                          this.state.privK,

                          this.claimCallbackPrepProgress,
                          this.claimCallbackBroadcastProgress,
                          this.claimFuncErrorCallback,
//FIXME: empower forAFriend, and additionalBalance
                          false,
                          0,
                        )
    if ( newTx !== null ) {
      shmalert("Tester claimSingleDomain() success for " + nameToClaim + "! " + newTx)

      this.setState({newestSingleTx: newTx, newestSingleDomain: nameToClaim})

      console.warn("FIXME: testerApp claimSingleDomain(): DECIDE WHAT TO DO WITH attemptToClaim results: keyUsedToCLaim, newTx")

    } else {
      alert("Tester APP claimSingleDomain() FAILED for " + nameToClaim)
    }

    } finally {
      this.updateWalletSummary()
    }

  }  // claimSingleDomain()

  generateRandomDomainName(lengthOfEachDomain = 5, domainNamePrefix = 'ttt') {
    const charsToUse = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t']
    const sizeOfCharsArray = charsToUse.length

    let thisDomain = domainNamePrefix
    const prefixLen = domainNamePrefix.length
    for ( let j = 0; j < lengthOfEachDomain - prefixLen; j++ ) {
      const charIndex = Math.floor( Math.random() * sizeOfCharsArray )
      const thisChar = charsToUse[ charIndex ]
      thisDomain += thisChar
    }

    return thisDomain.toLowerCase()
  }
  generateMultipleRandomDomainNames(numToGenerate = 1, lengthOfEachDomain = 5, domainNamePrefix = 'ttt') {
    const domainsToForm = new Array(numToGenerate)
    for ( let i = 0; i < numToGenerate; i++ ) {
      const thisDomain = this.generateRandomDomainName(lengthOfEachDomain, domainNamePrefix)
      console.error("domain " + i + " is " + thisDomain)
      domainsToForm[ i ] = thisDomain
    }

    return domainsToForm
  }

  async claimMultipleRandomDomains(dummy, dummy2, numToClaim = 5, alreadyGenerated = null, progressFunc= () =>{}, alsoPostToThem = false, useOldBlockHeights = false) {
    // n = 3:  ~27 sec
    // n = 5:  ~44 sec

    // APPROXIMATELY: 9 seconds per 5/6-letter claim (Oct 8, 2024)

    //const domainsToForm = new Array(numToClaim)
    const lengthOfEachDomain = 5

    console.warn("numToClaim: ", numToClaim)

    const domainsToForm = alreadyGenerated === null ?
              this.generateMultipleRandomDomainNames(numToClaim, lengthOfEachDomain)
                :
              alreadyGenerated

    console.warn("To review, these are the domains to claim: ", domainsToForm)

    shmalert("Will now iteratively claim each of these domains...")

    for ( let i = 0; i < domainsToForm.length; i++ ) {
      console.error("\n\n============== domain " + i + " ===============")

      if ( alsoPostToThem ) {
        progressFunc("Will now attempt to claim domain " + domainsToForm[i] + " - then POST to it a few times")
        await this.claimAndPost(null, null, domainsToForm[i], false, useOldBlockHeights)
      } else {
        progressFunc("Will now attempt to claim domain " + domainsToForm[i])
        await this.claimSingleDomain(null, null, domainsToForm[i], useOldBlockHeights)
      }

      const extraVerbage = alsoPostToThem ? " - and also POSTED on it" : ""
      shmalert("claimMultiRandos: We THINK we may have claimed " + domainsToForm[i] + extraVerbage + ".  Will continue looping...")
    }
    console.error("\n\n==============  DONE  ===============")

    console.warn("\n\nTo review, these are the domains we tried claiming: ", domainsToForm)
    if ( alsoPostToThem ) {
      shmalert("We think we're done CLAIMING (and POSTING on) multiple domains - check if successful")
    } else {
      alert("We think we're done CLAIMING multiple domains - check if successful")
    }
  }

  async seekThenGuestPost(dummy, dummy2,
                          guest = null, host = null,
                          reps = 0,
                        
                          someProgressFunc = null) {

    const aProgressFunc = someProgressFunc === null ? /*console.warn*/ alert : someProgressFunc

    await this.maybeInitializeFundingParams()

    try {

    let i = 0
    let ourDomainFromWhichToPost
    do {
      if ( i === 3 ) {
        console.error("seekThenGuestPost(): giving up on user choosing a guest domain after " + i + " tries")
        return
      }

      ourDomainFromWhichToPost = guest ? guest : prompt("Please enter a VALID/EXISTING guest domain, OF OURS, FROM which to POST:", "someDomain")
      ++i
    } while ( ourDomainFromWhichToPost === null || ourDomainFromWhichToPost.length < 1 || ourDomainFromWhichToPost.length > 38 );

    ourDomainFromWhichToPost = ourDomainFromWhichToPost.toLowerCase()


    let j = 0
    let domainOnWhichToPost
    do {
      if ( j === 3 ) {
        console.error("seekThenGuestPost(): giving up on user choosing a host after " + j + " tries")
        return
      }

      domainOnWhichToPost = host ? host : prompt("Please enter a VALID/EXISTING host domain ON which to POST:", "someHost")

      if ( domainOnWhichToPost === ourDomainFromWhichToPost ) {
        alert("ERROR: when guest-posting, the guest domain (" + ourDomainFromWhichToPost
            + "), and host domain must be different.")
        domainOnWhichToPost = null
      }
      ++j
    } while ( domainOnWhichToPost === null || domainOnWhichToPost.length < 1 || domainOnWhichToPost.length > 38 );

    const totalReps = reps > 0 ? reps : parseInt(prompt("Enter the total number of GUEST posts to make (1-50): ", "1"));
    if ( totalReps < 1 || totalReps > 50 ) {
      console.error("Invalid # of guest-post reps (min 1. max 50)")
      alert("Invalid # of guest-post reps (min 1. max 50)")
      return
    }
    if ( totalReps > 1 ) {
      shmalert("NOTE: each of the " + totalReps + " guest-post iterations will involve a full seek for BOTH the GUEST, and the HOST.")
    }

    const theDate = new Date().toLocaleString();
    this.setState({baseContent: "seekThenGuestPost() test started at " + theDate
                  + ". Will SEEK, then publish " + totalReps + " GUEST posts. Iteration: "})

    let readyToGuestPost = false

    // find tip of OUR domain

    const progressFunc = (progString) => {
      //console.error("IMPLEMENT progressFunc() for seekThenPost() call to findTipOfDomain()")
      console.warn("seekThenGuestPost() progress: ", progString)
    }
    const finishCanceling = (parent) => {
      console.error("IMPLEMENT finishCanceling() for seekThenPost() call to findTipOfDomain()")
    }
    const doneFunc = (parent) => {
      console.error("IMPLEMENT doneFunc() for seekThenGuestPost() call to findTipOfDomain()")
      shmalert("is this the same as processSearchResults()? prob not. Find out.")
    }
    const processSearchResults = async (txId,
                                        found, owned,
                                        status,
                                        finalQRes, latestPeriodicalRes, latestTransRes) => {
      console.error("processSearchResults() for seekThenGuestPost() call to findTipOfDomain()")

      console.warn("  status: ", status)
      console.warn("  txId: ", txId)
      console.warn("  found: ", found)
      console.warn("  owned: ", owned)

      if ( status !== 'success' ) {
        alert("Our guest-post seek (to our " + ourDomainFromWhichToPost + ") wasn't 100% successful.\n\n\nFIXME: Take a closer look why not. <-----")
        return
      }

      this.setState({guestTipTxId: txId})
      await this.allowSetStateToRipple()

      readyToGuestPost = true
      console.warn("NOTE: next we'll post, but in BASE function - not here.")
    }
    const visitTheGuestFunc = (guestLimb) => {
      const visitTheGuest = ourDomainFromWhichToPost === guestLimb
      console.error("visitTheGuestFunc() for seekThenGuestPost() call to findTipOfDomain()")
      return visitTheGuest
    }

    for ( let j=0; j < totalReps; j++ ) {
      aProgressFunc("   seeking to tip of " + ourDomainFromWhichToPost + " - from where we'll guest-post somewhere")
      await findTipOfDomain(window.shizzleContext,
                            this,

                            this.props.blockHeight,   //NEW: to help reduce queries on
                                                      //     Quarterlies, and Periodicals

                            progressFunc,
                            finishCanceling,
                            doneFunc,

                            ourDomainFromWhichToPost, //target
                            processSearchResults,

                            visitTheGuestFunc)

                            //checkIfCanceledFunc,
                            //guestPostWeAreAPartyToCB)

      shmalert("testerAPP: seekThenGuestPost(): done seeking")

      console.warn("readyToGuestPost = " + readyToGuestPost)
      if ( !readyToGuestPost ) {
        alert("testerAPP seekThenGuestPost() wasn't ready to post, for some reason")
        return
      }

      console.warn("STATE.guestTipTxId: ", this.state.guestTipTxId)
      // get and DECODE the actual LATEST tx (just-now FOUND)
      const guestTipDtx = await queryFetchDecodeTx(window.shizzleContext, this.state.guestTipTxId, await openDB(), false)
      const dtx = guestTipDtx

      console.warn("decoded tx (of tip of GUEST domain " + ourDomainFromWhichToPost + "): ", guestTipDtx)

      shmalert("It's time to Guest POST from this tip")

      const bestOutput = chooseOurTransientOutputForGuestPost(dtx, ourDomainFromWhichToPost)
      if ( bestOutput === -2 ) {
        alert("ERROR: while trying to prepare to guest-post, we found that the tip of domain " + ourDomainFromWhichToPost + " isn't a TRANSIENT.\n\nThis domain is not appropriate for this test right now.")
        return
      } else if ( bestOutput === -1 ) {
        alert("testerApp: seekTheGuestPost() Couldn't EASILY find an appropriate output from which to guestPost (from txId " + this.state.guestTipTxId + ")")

        alert("IMPLEMENT ME: see code in surfer's handleSubmitGuestPost() to potentially take evasive maneuvers for the GUEST")
        return
      }

      const latestGuestTxIdFromWhichToBuild = this.state.guestTipTxId
      const guestDtx = guestTipDtx
      const guestBestOutputNum = bestOutput
      const guestOutputStateOnWhichToBuild = dtx.outputStates[ bestOutput ]

      console.log("seekThenGuestPost(): param latestGuestTxId...: " + latestGuestTxIdFromWhichToBuild)
      console.log("seekThenGuestPost(): param guestDtx: ", guestDtx)
      console.log("seekThenGuestPost(): param guestBestOutputNum: " + guestBestOutputNum)
      console.log("seekThenGuestPost(): param guestOutputStateOnWhichToBuild: ", guestOutputStateOnWhichToBuild)
      console.log("seekThenGuestPost(): param ourDomainFromWhichToPost: ", ourDomainFromWhichToPost)



      shmalert("About to call seekThenPost() from seekThenGuestPost(). Check console for relevant params.")



      //FIXME: compare this code with that in surfer's handleSubmitGuestPost()
      //       Does that function effectively perform a findTipOfDomain()?



      // Call seekThenPost with 6+ specified GUEST-POST-related params:
      //   isAGuestPost
      //   latestGuestTxIdFromWhichToBuild
      //   guestDtx
      //   guestBestOutputNum
      //   guestOutputStateOnWhichToBuild
      //   ourDomainFromWhichToPost

      aProgressFunc("    Will now seek to tip of " + domainOnWhichToPost + ", and guest-post THERE")
      await this.seekThenPost(null, null,

                              true,
                              latestGuestTxIdFromWhichToBuild,
                              guestDtx,
                              guestBestOutputNum,
                              guestOutputStateOnWhichToBuild,
                              ourDomainFromWhichToPost,

                              domainOnWhichToPost,
                            
                              0,
                              aProgressFunc !== null ?
                                  aProgressFunc : progressFunc)

    } // loop: guest-post {totalReps} times

    shmalert("testerApp: seekThenGuestPost is done: " + totalReps + " guest-posts from " + ourDomainFromWhichToPost)

    } finally {
      this.updateWalletSummary()
    }
  }

  async kickOffMultiStepGenTest( parent,
                              progressFunc,
                              finishCanceling,
                              doneFunc,
                              target,
                              plmResetFunction) {
    alert("testerApp: kickOffMultiStepGenTest(): we've been asked to KICK-OFF a GEN,claim,guest-post test")

    this.plmResetFunction = plmResetFunction

    this.multiStepTest(null, null,

                      3, //4,      // num of domains to generate, claim, then post 3x to
                      8, //36,     // num of guest-posts to make (from 1 claimed, to some other claimed)

                      true,  //trueGenOrFalsePick
                      'sg', //sss',    // domainNamePrefix

                      progressFunc
    )
  }
  async kickOffMultiStepPickTest( parent,
                              progressFunc,
                              finishCanceling,
                              doneFunc,
                              target,
                              plmResetFunction) {
    alert("testerApp: kickOffMultiStepPickTest(): we've been asked to KICK-OFF a PICK,guest-post test")

    this.plmResetFunction = plmResetFunction

    this.multiStepTest(null, null,

                      3,
                      3,

                      false,  //trueGenOrFalsePick
                      'ttt',    // domainNamePrefix

                      progressFunc
    )
  }
  async kickOffPostToDomainWeAlreadyOwn(parent,
                                        progressFunc,
                                        finishCanceling,
                                        doneFunc,
                                        target,
                                        plmResetFunction) {
    alert("testerApp: kickOffPostToDomainWeAlreadyOwn(): we've been asked to KICK-OFF a test")

    this.plmResetFunction = plmResetFunction

    this.seekThenPost(null, null,

                      false, null, null, null, null,
                        //null, null, 0,
                        'something', 'bilbo', 5,

                      progressFunc
    )
  }

  async seekThenPost( dummy, dummy2,

                      isAGuestPost = false,
                      latestGuestTxIdFromWhichToBuild = null,
                      guestDtx = null,
                      guestBestOutputNum = null,
                      guestOutputStateOnWhichToBuild = null,
                      ourDomainFromWhichToPost = null,

                      domain = null,  // the domain on which to post
                      repsIfNotAGuestPost = 0,

                      aProgressFunc = null
  ) {

    await this.maybeInitializeFundingParams()

    try {

    // if no progressFunc is passed-in, use alert()
    const someProgressFunc = aProgressFunc === null ? alert : aProgressFunc

    let i = 0
    let domainOnWhichToPost
    do {
      if ( i === 3 ) {
        console.error("seekThenPost(): giving up on user after " + i + " tries")
        return
      }

      domainOnWhichToPost = domain ? domain : prompt("Please enter a VALID/EXISTING domain ON which to POST:", "someDomain")

      if ( isAGuestPost && (domainOnWhichToPost === ourDomainFromWhichToPost) ) {
        someProgressFunc("ERROR: when guest-posting, and the guest domain (" + ourDomainFromWhichToPost
            + "), and host domain must be different.")
        domainOnWhichToPost = null
      }
      ++i
    } while ( domainOnWhichToPost === null || domainOnWhichToPost.length < 1 || domainOnWhichToPost.length > 38 );

    domainOnWhichToPost = domainOnWhichToPost.toLowerCase()

    let totalReps = isAGuestPost ? 1 : repsIfNotAGuestPost
    // if we're GUEST posting, we need to have the loop at the parent function
    // (seekTheGuestPost), so that each time it can advance the GUEST too.
    // So, if we're GUEST posting, totalReps here is 1
    if ( !isAGuestPost && (totalReps < 1 || totalReps > 50) ) {
      totalReps = parseInt(prompt("Enter the total number of posts to make (0-50): ", "1"));
      if ( totalReps < 1 || totalReps > 50 ) {
        someProgressFunc("Invalid # of reps (min 1. max 50)")
        return
      }
    }

    if ( !isAGuestPost ) {
      shmalert("Will post, " + totalReps + " times, on EXISTING domain: " + domainOnWhichToPost)

      const theDate = new Date().toLocaleString();
      this.setState({baseContent: "seekThenPost() test started at " + theDate
                    + ". Will SEEK, then publish " + totalReps + " posts. Iteration: "})
    }

    let readyToPost = false

    console.warn("Tester APP: SEEK then post on domain: ", domainOnWhichToPost)

    shmalert("seekThenPost(): about to seek to tip of domain " + domainOnWhichToPost)

    const progressFunc = (progString) => {
      console.warn("seekThenPost() findTipOfDomain() progress: ", progString)
    }
    const finishCanceling = (parent) => {
      console.error("IMPLEMENT finishCanceling() for seekThenPost() call to findTipOfDomain()")

      someProgressFunc("testerAPP  seekThenPost  finishCanceling (for findTipOfDomain) should now finish canceling.")
      this.setState({testCanceled: false})

      //FIXME: reset the PLM?
    }
    const doneFunc = (parent) => {
      console.error("IMPLEMENT doneFunc() for seekThenPost() call to findTipOfDomain()")
      shmalert("is this the same as processSearchResults()? prob not. Find out.")
    }
    const processSearchResults = async (txId,
                                  found, owned,
                                  status,
                                  finalQRes, latestPeriodicalRes, latestTransRes) => {
      console.warn("processSearchResults() for seekThenPost() call to findTipOfDomain()")

      console.warn("  status: ", status)
      console.warn("  txId: ", txId)
      console.warn("  found: ", found)
      console.warn("  owned: ", owned)

      shmalert("processSearchResults(): is this the same as doneFunc()? prob not. Find out.")

      if ( status !== 'success' ) {
        someProgressFunc("Our seek (to host " + domainOnWhichToPost + ") wasn't 100% successful Take a closer look why not. <----- found: " + found + ". owned: " + owned)
        return
      }

      this.setState({tipTxId: txId})
      await this.allowSetStateToRipple()

      readyToPost = true
      console.warn("NOTE: next we'll post, but in BASE function - not here.")
    }
    const visitTheGuestFunc = (guestLimb) => {
      const visitTheGuest = domainOnWhichToPost === guestLimb
      console.error("visitTheGuestFunc() for seekThenPost() call to findTipOfDomain()")
      return visitTheGuest
    }
    const checkIfCanceledFunc = () => {
      console.error("checkIfCanceledFunc() for seekThenPost() call to findTipOfDomain()")
      return this.state.testCanceled
      // false
    }
    const guestPostWeAreAPartyToCB = () => {
      console.error("IMPLEMENT guestPostWeAreAPartyToCB() for seekThenPost() call to findTipOfDomain()")
    }


    someProgressFunc("Now seeking the tip of (then publishing " + totalReps + " posts on) " + domainOnWhichToPost)

    await findTipOfDomain(window.shizzleContext,
                          this,

                          this.props.blockHeight,   //NEW: to help reduce queries on
                                              //     Quarterlies, and Periodicals

                          //aProgressFunc === null ? progressFunc : aProgressFunc,
                          progressFunc,
                          finishCanceling,
                          doneFunc,

                          domainOnWhichToPost, //target
                          processSearchResults,

                          visitTheGuestFunc,  //)

                          checkIfCanceledFunc)//,
                          //guestPostWeAreAPartyToCB)

    shmalert("testerAPP: seekThenPost(): done seeking.\n\n\nReady for posting: " + readyToPost)

    shmalert("readyToPost = " + readyToPost)
    if ( !readyToPost ) {
      someProgressFunc("testerAPP seekThentPost() wasn't ready to post, for some reason. Canceled? " + this.state.testCanceled)
      return
    }

    if ( checkIfCanceledFunc() ) {
      someProgressFunc("CANCELING test after seeking to tip of " + domainOnWhichToPost)
      return
    }

    someProgressFunc("Now decoding the tip of OUR (guest) domain...")

    console.warn("STATE.tipTxId: ", this.state.tipTxId)
    // get and DECODE the actual LATEST tx (just-now FOUND)
    const tipDtx = await queryFetchDecodeTx(window.shizzleContext, this.state.tipTxId, await openDB(), false)

    console.warn("decoded tx (of tip of domain " + domainOnWhichToPost + "): ", tipDtx)

    shmalert("It's time to POST to this tip")


    this.setState({newestSingleTx: this.state.tipTxId, newestSingleDomain: domainOnWhichToPost, newestDtx: tipDtx})

    await this.allowSetStateToRipple()

    shmalert("read the decoded tipDtx of what we just-now SEEKED to - in the console\n\nIt needs to be NON-null")

    shmalert("Tester seekThenPost() success for SEEKING-to-tip of " + domainOnWhichToPost + "! [" + this.state.tipTxId +
             "]\n\nNOW, however, we'll try POSTING from this position...")


    const finalProcessing = () => {}

    someProgressFunc("Will now publish " + totalReps + " posts on " + domainOnWhichToPost + "...")
    for ( let i=0; i < totalReps; i++ ) {
      someProgressFunc("  iteration " + (i+1) + " of " + totalReps + " posts on " + domainOnWhichToPost + "...")

      const success = await publishPost(window.shizzleContext,
                                        null,

                                        isAGuestPost,
                                        latestGuestTxIdFromWhichToBuild,
                                        guestDtx,
                                        guestBestOutputNum,
                                        guestOutputStateOnWhichToBuild,

                                        finalProcessing,
                                        this.contextFuncForPosting,
                                        this.milestoneFuncForPosting,
                                        this.errorFuncForPosting)

      shmalert("seekThenPost()   ITERATION " + i + " (base-0) success for posting on "
            + domainOnWhichToPost + ": " + success)
      console.warn("seek then post: post " + i + "/" + totalReps + " (base-0) on " + domainOnWhichToPost + ": success = " + success)

      if ( checkIfCanceledFunc() ) {
        someProgressFunc("CANCELING test after " + (i+1) + " posts published")
        return
      }
      if ( !success ) {
//        alert("Tester APP seekThenPost() FAILED  posting on TIP of " + domainOnWhichToPost)
        someProgressFunc("We had a problem publishing #" + i + " (of " + totalReps + ") on " + domainOnWhichToPost)
        return
      } else {
        someProgressFunc("     SUCCESS publishing to " + domainOnWhichToPost) //FIXME: remove this?
      }

    } // publish multiple times

    someProgressFunc("DONE publishing " + totalReps + (isAGuestPost ? "GUEST" : "")
                  + " posts on " + domainOnWhichToPost)
  
    if ( !isAGuestPost ) {
      shmalert("Tester APP seekThenPost() SUCCEEDED in posting " + totalReps + " times on " + domainOnWhichToPost)
    }

    } finally {
      this.updateWalletSummary()
    }
  } // seekThenPost()

  async multiStepTest(dummy, dummy2,
                      numDomains = 3,
                      numOuterLoopIterations = 3,
                      trueGenerateOrFalsePick = false,
                      domainNamePrefix = 'ttt',
                      aProgressFunc = null) {

    await this.maybeInitializeFundingParams()

    try {

      //const numDomains = 3                 // <-------- Play with this
      //const numOuterLoopIterations = 3 //6    // <-------- Play with this

      const theProgressFunc = aProgressFunc === null ? console.warn : aProgressFunc

      //generate 3 random domain names: A, B, C
      //const claimedDomains = trueGenerateOrFalsePick ?
      //        this.generateMultipleRandomDomainNames(numDomains, lengthOfEachDomain, domainNamePrefix)
      //          :
      //        [] //FIXME: pick from a list of domains we ALREADY OWN

      theProgressFunc("Kicking-off a multi-step test...")

      let claimedDomains
      if ( trueGenerateOrFalsePick ) {

        const lengthOfEachDomain = 4//6  // only relevant if we're GENERATING+claiming domains

        claimedDomains = this.generateMultipleRandomDomainNames(numDomains, lengthOfEachDomain, domainNamePrefix)

        console.warn("We'll CLAIM these domains (and POST on each): ", claimedDomains)
        await this.claimMultipleRandomDomains(null, null, numDomains, claimedDomains, theProgressFunc, true)

      } else {
        theProgressFunc("Now choosing domains to use...")
        let domainCount = 0
        const db = await openDB()
        const allMyDomains = await findAllDomainsOfMine(db)
        claimedDomains = [] //new Array(allMyDomains.length)
        console.warn("multiStepTest(): all of my domains: ", allMyDomains)

        // Start from a RANDOM index, and loop around from there
        // This should keep the alphabetically-early domains from dominating
        // RECALL: we're only choosing the first 'numDomains' of these domains
        //         which begin with the 'domainNamePrefix'
        const startingIdx = Math.floor( Math.random() * allMyDomains.length)
        console.warn("NOTE: starting from domain with index " + startingIdx)
        for ( let i = 0; i < allMyDomains.length; ++i ) {
          // calculate the actual index, j
          const j = (i + startingIdx) % allMyDomains.length
          //console.error("ACTUAL IDX: ", j)

          if ( !allMyDomains[j].outdated ) {

              if ( allMyDomains[j].name.startsWith(domainNamePrefix) ) {
                console.warn("GOOD ONE: " + allMyDomains[j].name)
                claimedDomains.push( allMyDomains[j].name )
                theProgressFunc("  chose domain: " + allMyDomains[j].name)
                ++domainCount
              }

              if ( domainCount === numDomains ) {
                console.error("ALL good: we found enough domains: " + domainCount)
                break
              }
          }
        }

        if ( domainCount < numDomains ) {
          console.error("PROBLEM: we only found " + domainCount + " domains that begin with " + domainNamePrefix)
          alert("PROBLEM: we only found " + domainCount + " domains that begin with " + domainNamePrefix)
          return
        }

        console.warn("We'll use these EXISTING domains: ", claimedDomains)
      }


      shmalert("We've got our domains. It's time to direct " + numOuterLoopIterations +
            " random guest-posts...")

      // set value for outerLooop reps: M
      // FUTURE: set value for innerLoop reps: N
      //   FOR NOW: N=1
      //
      // Do this M times
      //   choose random GUEST domain A
      //   choose random HOST domain B
      //    - guestPost N times from A to B


      theProgressFunc("Will now conduct " + numOuterLoopIterations + " 'seek-then-guest-post' tests")
      
      for ( let i = 0; i < numOuterLoopIterations; ++i ) {
        const fromDomainNum = Math.floor( Math.random() * numDomains)
        let toDomainNum
        let r = 0
        do {
          //if ( r > 0) console.warn("whoops. repeating")
          toDomainNum = Math.floor( Math.random() * numDomains )
          ++r
        } while ( toDomainNum === fromDomainNum )

        console.warn("Iteration " + (i+1) + " (of " + numOuterLoopIterations +
                      "): Will send (guest-post) from " +
              claimedDomains[ fromDomainNum ] + " to " + claimedDomains[ toDomainNum ])
        theProgressFunc(" [" + i + "/" + numOuterLoopIterations + "]:  >>>  Will guest-post from " +
              claimedDomains[ fromDomainNum ] + " to " + claimedDomains[ toDomainNum ] + "...")

        await this.seekThenGuestPost( null, null,
                                claimedDomains[ fromDomainNum ],
                                claimedDomains[ toDomainNum ],
                                1,//)//,
                                aProgressFunc)
      }

    } finally {
      this.updateWalletSummary()
    }

  }

  async claimAndPost(dummy, dummy2, domainToClaim = null, alertOnSuccess = true, useOldBlockHeights = false) {

    await this.maybeInitializeFundingParams()

    try {

      let i = 0
      let nameToClaim
      do {
        nameToClaim = domainToClaim ? domainToClaim : prompt("Please, enter a VALID domain to claim:", "someDomain")
        ++i
      } while ( i < 3 && (nameToClaim === null || nameToClaim.length < 1 || nameToClaim.length > 38) )
      if ( i === 3 ) {
        console.error("claimAndPost(): GIVING UP on user")
        return
      }
      nameToClaim = useOldBlockHeights ?
                        'old' + nameToClaim.toLowerCase()
                      :
                        nameToClaim.toLowerCase()

      if ( useOldBlockHeights && !HOLD_BACK_BLOCKHEIGHT_FOR_TESTING ) {
        alert("Since you're looking to operate with OLD blockHeights, you need to set HOLD_BACK_BLOCKHEIGHT_FOR_TEST to true." +
              "\n\nPlease see file harnessConstants.js"
        )

        return
      } else {
        shmalert("useOldBlockHeights: " + useOldBlockHeights)
        shmalert("You've got the correct value for 'HOLD_BACK_BLOCKHEIGHT_FOR_TESTING' - set to " + HOLD_BACK_BLOCKHEIGHT_FOR_TESTING)
      }

      if ( useOldBlockHeights ) {
        alert("NOTE: domain will be claimed - but prepended with 'OLD'")
      }

      if ( alertOnSuccess ) {
        alert("NOTE: there will be no PROGRESS MODAL to show progress while any domains are being claimed, and posted to.")
      }

      // this MIGHT be the number of POSTS to make after claiming
      // NOWADAYS, 3 is required before being able to RECEIVE guest-posts
      const totalReps = 3
      const theDate = new Date().toLocaleString();
      this.setState({baseContent: "claimAndPost() test started at " + theDate + ". Will CLAIM, then publish " + totalReps + " posts. Iteration: "})

      console.warn("Tester APP: claim and post on: ", nameToClaim)

      shmalert("nameToClaim: " + nameToClaim + "  Will analyze...")

      await analyzeDomainForClaiming( window.shizzleContext,
                                      this,
                                      this.analysisProgressFunc,
                                      this.analysisFinishCanceling,
                                      this.analysisDone,

                                      nameToClaim,

                                      this.props.blockHeight,

                                      this.checkIfAnalysisCanceled,
                                      this.analysisJobWasCanceled,
                                      this.cbProcessSearchResults, // decodes, examines final tx for expired, and determines newOwnerCount
                                      this.cbSetupBuildLoop        //used only by express/loop approach
                                    )

      //checksucessfail?
      shmalert("claimAndPost(): analysis complete. Will now attemptToClaim() " + nameToClaim)

  // NOTE: processSearchResults fills-out these params - but they first need to ripple...

      await this.allowSetStateToRipple()

      shmalert("about to claim: " + nameToClaim)

      console.warn("TESTER: claimAndPost(): dummy setState has rippled. will now ATTEMPTtoClaim()...")
      const {keyUsedToClaim, newTx} = await attemptToClaim(window.shizzleContext,
                            nameToClaim,

                            this.state.found,

                            this.props.blockHeight,
                            this.state.furthestTxId,      //loopTxId,
                            this.state.furthestTxDecoded, //loopTxStr,     //Used by expressClaimFunc
                            this.state.reachedLimb,       //loopTxLimbName,
                            this.state.outputIndex,       //loopNextOutIdx,

                            this.state.newOwnerCount,
                            this.state.owned,
                            this.state.expired,
                            this.state.buildingOnModeP,

                            this.state.privK,

                            this.claimCallbackPrepProgress,
                            this.claimCallbackBroadcastProgress,
                            this.claimFuncErrorCallback,
  //FIXME: empower forAFriend, and additionalBalance
                            false,
                            0,
                          )
      if ( newTx === null ) {
        alert("Tester APP claimAndPost() FAILED attemptToClaim() of " + nameToClaim)
        return
      }
      console.warn("TESTER: claimAndPost(): succesfully claimed " + nameToClaim +". Will now DECODE txId " + newTx)

      console.warn("IMPLEMENT ME: testerApp claimAndPost(): SUCCESS claiming " + nameToClaim + ".\n\nDECIDE WHAT TO DO WITH attemptToClaim result member: keyUsedToClaim")


    //alert("NOW is when we should pause. is it possible there's a problem/missing await somewhere?")

      // NOTE: traversalFunctions' publishPost() pauses after posting - to avoid
      //       FAILED queries (see line 3261). What we're trying to avoid here
      //       is TRUNCATED responses. It's not clear if this will help. We may
      //       need to incorporate re-try logic into 
      //       7/10/25  had trouble with WoC truncated response (just posting). Created new
      //                const to centralize this delay (initially 8100 ms)
      await mySleep(PROVIDER_PROPAGATION_DELAY_MS, "pausing to allow new (potentially MULTIPLE) transactions to propagate...")


      // get and DECODE the actual new tx (just-now claimed)
      const newDtx = await queryFetchDecodeTx(window.shizzleContext, newTx, await openDB(), false)

      console.warn("newDtx (of claim): ", newDtx)

      this.setState({newestSingleTx: newTx, newestSingleDomain: nameToClaim, newestDtx: newDtx})

      await this.allowSetStateToRipple()

      shmalert("read the decoded newestDtx/newDtx of what we just-now CLAIMED - in the console\n\nIt needs to be NON-null")

      shmalert("Tester claimAndPost() success for CLAIMING " + nameToClaim + "! " + newTx +
              +"\n\nNOW, however, we'll try POSTING on this new claim..."
      )

      const finalProcessing = () => {}

      shmalert("We're about to perform " + totalReps + " posts on: " + nameToClaim)

      for ( let i=0; i < totalReps; i++ ) {
        const success = await publishPost(window.shizzleContext,
                                          null, false, null, null, null, null,
                                          finalProcessing,
                                          this.contextFuncForPosting,
                                          this.milestoneFuncForPosting,
                                          this.errorFuncForPosting)

        shmalert("claim and post()   ITERATION " + i + " (base-0) success for posting on "
              + nameToClaim + ": " + success)
        console.warn("claim and post: post " + i + "/" + totalReps + " (base-0) on " + nameToClaim + ": success = " + success)
    
        if ( !success ) {
          alert("Tester APP claimAndPost() FAILED iterated posting " + i + " on " + nameToClaim)
          return
        }

      } // publishing loop
      
      if ( alertOnSuccess ) {
        alert("claim-and-post (" + totalReps + " reps) on " + nameToClaim + " SUCCEEDED !")
      }

    } finally {
      this.updateWalletSummary()
    }
  }  // claimAndPost()

  closeWallet() {

    if ( !confirm("Are you sure you want to exit?") ) {
      return
    }
    console.error("CLOSING WALLET:  setState privK, fundingAddress to null")
    this.setState({privK: null, fundingAddress: null, showBlockHeightTests: false})

    console.error("CALLING parent's this.props.handleSignInOutClick()")
    this.props.handleSignInOutClick(this.props.parent)
  }

  async handleWalletClick() {
    // It's possible this is the FIRST time wallet is being clicked, and we've NEVER yet
    // fetched the utxos (initialized wallet params)
    await this.maybeInitializeFundingParams()

    await this.updateWalletSummary()

    this.props.handleWalletClick()
  }

  async updateWalletSummary() {
    const db = await openDB()
    const freeP2PKHsCount = await getAvailableP2PKHsCount(db)
    const freeRabinsCount = await getAvailableRabinsCount(db)
    const utxoAnalysis = analyzeUTXOs(getProviderContext(shizzleContext).localUTXOs, this.props.bsvPriceUSD, false) // not verbose

    // calcs taken from walletFunder, but, maybe belongs in walletFuncs
    const UsPennyValue = ((utxoAnalysis.satsSum * this.props.bsvPriceUSD) / 1000000).toFixed(1)
    console.log("calculated total value of " + UsPennyValue + "¢") //xxxxx double?

    //console.warn("balancePennies: ", this.props.balancePennies)
    console.warn("parent-reported balancePennies: " + this.props.balancePennies)

    const bestUtxoPennyValue = ((utxoAnalysis.bestUTXO.satoshis * this.props.bsvPriceUSD) / 1000000).toFixed(1)
    console.log("calculated best UTXO value of " + bestUtxoPennyValue + "¢")  //xxxxx NaN?

    this.setState({freeP2PKHsCount: freeP2PKHsCount, freeRabinsCount: freeRabinsCount})
    console.error("UPDATE WALLET SUMMARY:  analysis: ", utxoAnalysis)
  }

  showBlockHeightRelatedTests() {
    console.log("Will show blockHeight-related tests...")
    this.setState({showBlockHeightTests: true, showMigrationOptions: false})
  }
  showNormalTests() {
    console.log("Will show the NORMAL tests...")
    this.setState({showBlockHeightTests: false, showMigrationOptions: false})
  }
  showMigrationRelatedOptions() {
    console.log("Will show migration-related options...")
    this.setState({showBlockHeightTests: false, showMigrationOptions: true})
  }

  async readMigrationDataFromBlockchain() {

      //const migrationDataObj = await processMigrationData(merkleLeavesJSON)
      const migrationDataObj = await readAndProcessMigrationDataFromBlockchain(window.shizzleContext)

      if ( migrationDataObj !== null ) {
        this.setState({ merkleLeavesJSON: migrationDataObj.merkleLeavesJSON,
                        rawHexLeaves:     migrationDataObj.rawHexLeaves,    // 1024 raw hex
                        merkleTreeArray:  migrationDataObj.merkleTreeArray  // TREE of hashes - leaves ARE hashes
                    })
      }

  }

  async publishMigrationNodes() {
    await this.maybeInitializeFundingParams()

    try {
      await publishMigrationDataFromIdbToBlockChain(getProviderContext(window.shizzleContext))
    } catch (error) {
      console.error("trouble building merkle-data tx: ", error)
      console.error("IMPLEMENT ME: add a MODAL instead of this alert")
      alert("We had trouble publishing migration merkle leaves to a transaction")
    } finally {
      this.updateWalletSummary()
    }
  }

  async generateMerkleProof() {

    // freeze buttons?

    // show modal:
    //   - offer option for builder, or domain
    //    - offer a searchable dropdown of domains

    // WHAT ABOUT a PATH to a final destination <---- if we select a domain
    //   - maybe see how far it's ALREADY restored (if at all)
    //   - will build N transactions to restore/migrate N builders (if not already restored)
    //   - will build final tx for the destination domain

    //// BTW: perhaps ANYONE could restore/migrate a given domain <----- should I do this? hmm
    //        perhaps BETTER for user to ---> so it's a more normal flow

    const domainName = prompt("Enter a node to generate a merkle proof for: ")
    console.log("node/domain: ", domainName)

    console.log("state.merkleLeavesJSON[]: ", this.state.merkleLeavesJSON)

    let foundDomainIdx = -1
    for ( let i = 0; i < this.state.merkleLeavesJSON.length; i++ ) {
      if ( this.state.merkleLeavesJSON[i].dom === domainName ) {
        foundDomainIdx = i
        console.warn("FOUND match in JSON leaf node " + i + ": ", this.state.merkleLeavesJSON[i])
        console.error("here's the corresponsing rawHexLeaves[" + i + "]: " + this.state.rawHexLeaves[foundDomainIdx])
        break
      } else {
        //console.warn("node " + i + ": ", this.state.merkleLeavesJSON[i])
      }
    }

    let base
    if ( foundDomainIdx === -1 ) {
      alert("Can't find that domain/node: " + domainName + "\n\nHave you LOADED the merkle data yet?")
      return;
    }

    const numMerkleLevels = this.state.merkleTreeArray.length
    alert("It seems there are " + numMerkleLevels + " levels in the merkle tree")

    console.warn("found idx: ", foundDomainIdx)
    console.log("state.merkleLeavesJson[i]: ", this.state.merkleLeavesJSON[foundDomainIdx])
    console.error("state.rawHexLeaves[i]: ", this.state.rawHexLeaves[foundDomainIdx])
    console.error("CHECK THIS NEXT ONE, below, matches HASH of above ! ! < - - -")
    console.log("state.merkleTreeArray[" + (numMerkleLevels-1) + "][i]: ", this.state.merkleTreeArray[numMerkleLevels-1][foundDomainIdx])


    //NOTE: see processRegisteredNode() (line 2807ish) for pre-image format of a leaf

alert("When building an actual proof, MAYBE we want to start with the actual pre-image.")

    // raw HEX leaves
    base = this.state.rawHexLeaves[foundDomainIdx]

    let ourHash = bsv.crypto.Hash.sha256( Buffer.from(base, 'hex' ) ).toString('hex')
    console.warn("ourHash: " + ourHash)


    alert("NOW, we'll build a FULL merkle proof - of " + numMerkleLevels + " levels...")
    const proofEntries = []
    let foundAtIdx
    for ( let level = numMerkleLevels-1; level > 0; level-- ) {

      //
      //  a SANITY check
      //
      let allWell = false
      for ( let i = 0; i < this.state.merkleTreeArray[level].length; i++ ) {
        if ( this.state.merkleTreeArray[level][i] === ourHash ) {
          console.error("FOUND our hash in merkleTreeArray[ " + level + " ] entry " + i + "   < = = = = = = <<<")
          allWell = true
          foundAtIdx = i
          break;
        }
      }
      //alert("check console if we found our hash in merkleTreeArray[ " + level + " ][i]")
      if ( !allWell ) {
        throw Error("CODE ERROR in merkleTree proof - level " + level)
      }

      const otherIdxAtThisLevel = foundAtIdx + (foundAtIdx % 2 === 0 ? 1 : -1 )
      const weGoFirst = foundAtIdx % 2 === 0
      console.log("other idx: " + otherIdxAtThisLevel)
      const otherHash = this.state.merkleTreeArray[level][otherIdxAtThisLevel]

      proofEntries.push({weGoFirst: weGoFirst, otherHash: otherHash})

      const newBase = weGoFirst ?
                          ourHash + otherHash
                      :
                          otherHash + ourHash
      if ( weGoFirst ) {
        console.log("will hash() our + other: " + ourHash + " + " + otherHash)
      } else {
        console.log("will hash() other + our: " + otherHash + " + " + ourHash)
      }
      const newHash = bsv.crypto.Hash.sha256( Buffer.from(newBase, 'hex' ) ).toString('hex')
      //bsv.crypto.Hash.sha256( Buffer.from(left, 'hex') ).toString('hex');
      console.error("New hash: " + newHash)

      console.error("\n----------- next iteration, with THAT NEW hash ----------\n\n")
      ourHash = newHash
      console.error("About to iterate AFTER level " + level)
    }

    console.error("\n\n\n\nProof entries: ", proofEntries)
    console.error("\n\n\nWill now hash the proof entries, to arrive at the ROOT ASH")


    // DOUBLE-CHECK the proof. USE the proof to reach the merkle root

    // 1 - start with raw values - to be hashed
    // 2 - successively concat with a hash at each level of the merkle proof
    //     (in the correct/provided order)
    // 3 - final hash MUST result in merkle proof

    // raw HEX leaves (field values: domain, ownerRabin, builderRabin, builderP2PKH)
    const theBase = this.state.rawHexLeaves[foundDomainIdx]
    let theHash = bsv.crypto.Hash.sha256( Buffer.from(theBase, 'hex' ) ).toString('hex')
    //let idx = foundAtIdx   currently, we're using the stored 'weGoFirst' boolean,
    //                       rather than re-derive, as we go, using the foundAtIdx
    for ( let i = 0; i < proofEntries.length; i++) {
      console.log("theHash at level " + i + ": ", theHash)
      const levelInfo = proofEntries[i]
      console.log("levelInfo: ", levelInfo)

      const newBase = levelInfo.weGoFirst ?
                    theHash + levelInfo.otherHash
                :
                    levelInfo.otherHash + theHash
      if ( levelInfo.weGoFirst ) {
        console.log("will hash() our + other: " + theHash + " + " +  levelInfo.otherHash)
      } else {
        console.log("will hash() other + our: " + levelInfo.otherHash + " + " + theBase.Hash)
      }
      const newHash = bsv.crypto.Hash.sha256( Buffer.from(newBase, 'hex' ) ).toString('hex')
      //bsv.crypto.Hash.sha256( Buffer.from(left, 'hex') ).toString('hex');
      console.error("New hash: " + newHash)

      console.error("\n----------- next iteration, with THAT NEW hash ----------\n\n")
      theHash = newHash
      console.warn("About to iterate AFTER level " + i)
    }

    console.error("\n\n\nTHE HASH: " + theHash)
    console.error("\nROOT Hash: " + this.state.merkleTreeArray[0][0])

    if ( theHash !== this.state.merkleTreeArray[0][0] ) {
      alert("FAILED")
    } else {
      alert("SUCCESS!")
    }

    alert("DONE.\n\nFIXME: consider if we just want to pass-in the foundAtIdx - instead of booleans")

  }

  closeMerkleTool() {
    this.setState({showMerkleModal: false})
  }
  showMerkleTool() {
    this.setState({showMerkleModal: true})
    console.log("state.rawHexLeaves: ", this.state.rawHexLeaves)
    console.log("state.merkleTreeArray[]: ", this.state.merkleTreeArray)
  }

  // cursory inspection of registered nodes (already saved to IDB)
  // builds a merkle tree (and root) of all nodes
  // NOPE: publishes nodes for use by all users (when migrating) - does NOT do this
  //FIXME: MAYBE extract to separate module - to share with user/app code
  async processRegisteredNodes() {

    const migrationDataObj = await processMigrationDataFromIDB()

    this.setState({ merkleLeavesJSON: migrationDataObj.merkleLeavesJSON,
                    rawHexLeaves:     migrationDataObj.rawHexLeaves,    // 1024 raw hex
                    merkleTreeArray:  migrationDataObj.merkleTreeArray  // TREE of hashes - leaves ARE hashes
    })
  }

  // scan shizzleTree with aim of collecting ALL builder nodes, and claimed domains that
  // existed before (and including) a given blockHeight
  // SAVE results of scan - for later processing into a Merkle Tree - to aid in Migration 



  async scanOldDomains() {
    // recall, over time there can be multiple OWNERS 
    const domainsWithDups = await findAllDomainsOfMine(await openDB())
    console.log("ScanOldDomains: ", domainsWithDups)



    let oldDomainsWithDups = []
    for ( let i = 0; i < domainsWithDups.length; i++ ) {
      const name = domainsWithDups[i].name
      if ( name.startsWith('old') || name.startsWith( 'OLD' ) ) {
        oldDomainsWithDups.push( name )
      }
    }

        // remove duplicates (if multiple owners)
    const oldDomains = [...new Set(oldDomainsWithDups)];
    console.log("de-duplicated list: ", oldDomains)

    //FWIW: some css named colors:
    //      https://austingil.com/css-named-colors/
    const style = 'background-color: darkblue; color: white; font-style: italic; border: 5px solid darkorchid; font-size: 2em;'
    console.warn("%cWe found " + oldDomains.length + " 'OLD'-name domains.", style)
    if ( oldDomains.length === 0 ) {
      alert("NOTE: We found no 'old'-named domains to use.\n\nPlease claim a few with OLD blockHeights before proceeding.")
      return
    }

    const bold = "font-weight: bold";
    const normal = "font-weight: normal";
    for ( let i = 0; i < oldDomains.length; i++ ) {
      const name = oldDomains[i]
      console.warn("Found OLD domain: %c" + name + "%c", bold, normal)
    }

    //USE (OR simulate) where appropriate: ?blockHeightOverride={someHeight}

    return oldDomains
  }
  async measureSlackOfOldDomains() {
    const oldDomains = this.scanOldDomains()

    console.warn("old domains: ", oldDomains)

    alert("IMPLEMENT blockHeight-slack measurements")
  }

  async testReclaiming() {

    boldLog("Running testReclaiming() test")


    await this.maybeInitializeFundingParams()

    try {
      if ( HOLD_BACK_BLOCKHEIGHT_FOR_TESTING ) {
        alert("When testing RE-CLAIM (any ownership-changing) features it's usually best to set 'HOLD_BACK_BLOCKHEIGHT_FOR_TESTING to false.\n\n" +
              "ABORTING test."
        )
        return
      }

      const domainsToReclaim = await this.scanOldDomains()

      //FIXME: if there are none, then maybe CLAIM some?
      //       WELL, should advise user to first set HOLD_BACK_BLOCKHEIGHT_FOR_TESTING when claiming
      if ( domainsToReclaim.length === 0 ) {
        alert("There are no 'OLD' domains to test reclaiming :(")
        return
      }

      const finishCanceling = (parent) => {
        console.error("IMPLEMENT finishCanceling() for testReclaiming()")
      }
      const doneFunc = (parent) => {
        console.error("IMPLEMENT doneFunc() for testReclaiming()")
        shmalert("is this the same as processSearchResults()? prob not. Find out.")
      }

      const processSearchResults = async (txId,
                                          found, owned,
                                          status,
                                          finalQRes, latestPeriodicalRes=null, latestTransRes=null) => {
        console.error("processSearchResults() for testClaiming() call to findTipOfDomain()")

        console.warn("  status: ", status)          // want success (sorta. Eventually short-circuit to latest Q)
        console.warn("  txId: ", txId)              // EVENTUALLY we want this to be the latestQ
        console.warn("  found: ", found)
        console.warn("  owned: ", owned)
        console.warn("  FINAL Q: ", finalQRes)      // THIS, for now.   .status==='success', .txId

        if ( finalQRes.status !== 'success' ) {
          alert("Our seek to final Q (for renewing) wasn't 100% successful.\n\n\nFIXME: Take a closer look why not. <-----")
          return
        }

        console.error("We want to look at finalQ with txId of " + finalQRes.txId)

        // we do this so that we can access this info from the main thread
        // in parent function: testRenewal()
        this.setState({finalQTxId: finalQRes.txId})
        await this.allowSetStateToRipple()

      }  // inner processSearchResults()

      // At some point, maybe pick a RANDOM one?
      // PUT, ensure it CAN be renewed?
      const domainToReclaim = domainsToReclaim[ IDX_FOR_OLD_DOMAINS ]

      console.warn("ABOUT TO FIND TIP OF ", domainToReclaim)

      await findTipOfDomain(window.shizzleContext,
                            this,

                            this.props.blockHeight,   //NEW: to help reduce queries on
                                                      //     Quarterlies, and Periodicals

                            console.warn,             // progressFunc(string)
                            finishCanceling,
                            doneFunc,

                            domainToReclaim,          // target domain
                            processSearchResults,     // THIS is where we actually process the results

                            null,                     // 'visitTheGuestFunc' is only useful if we were tracking down the latest transient (which branch to follow)
                            () => {return false},     // don't worry about cancelling
                            null,                     //
                            true                      // Only bother finding the tip of the QUARTERLIES
                          )

      console.warn("We THINK we've got the latest Quarterly.  --->  finalQTxId: " + this.state.finalQTxId)

      const finalQTxId = this.state.finalQTxId

      if ( finalQTxId === null ) {
        console.warn("testReclaiming(): skipping domain check. We have no valid quarterly")
        alert("can't reClaim? check console")
        return
      }

      const db = await openDB()

      const quarterlyStats = await checkIfDomainExpiredOrRenewable(db, finalQTxId, this.props.blockHeight)

      //console.log("testClaiming(): quarterlyStats: ", quarterlyStats)
      //console.log("testRenewal(): qs.furthestQuarterlyDtx: ", quarterlyStats.furthestQuarterlyDtx)
      //console.log("testClaiming(): qs.furthestQuarterlyDtx.limbName: ", quarterlyStats.furthestQuarterlyDtx.limbName)

      console.error("furthest QStats of " + domainToReclaim + " (at txId " + finalQTxId + "):", quarterlyStats)

      if ( !quarterlyStats.expired ) {
        alert("WAIT a second. Domain " + domainToReclaim + " is NOT expired, so it can't be reclaimed.\n\n" +
              "You'll need to try a DIFFERENT domain.")     
      }
      // potentially helpful:
      //    .minBlockHeightForNextQuarterly    <----- use this to try renewing
      //    .furthestQuarterlyDtx    .outputStates[0]
      //                                  .blockNumInt
      //                                  .renewalDeadline
      //
      // MAYBE less helpful (IFF it's based on the ACTUAL, advanced, blockHeight)
      //    .expired
      //    .canBuildNewQuarterly
      //    .renewable
      //    .priceInSats
      //    .ownerP2PKH
      //    .potentialSaleFlag
      //    .potentialSaleMinBlock

      //TODO: MAYBE use a BOGUS blockheight when calling checkIfDomainExpiredOrRenewable() <------

      const furthestQDtx = quarterlyStats.furthestQuarterlyDtx
      const newTargetBlockHeight = furthestQDtx.outputStates[0].renewalDeadlineInt
      const currentBlockHeight = quarterlyStats.currentQuarterlyBlockHeight

      const blocksBeforeRenewalDeadline = newTargetBlockHeight - currentBlockHeight

      const blockHeightForReclaiming = newTargetBlockHeight + 400  //FIXME: double-check this
  alert("FIXME: in testReclaiming: verify that we CAN re-claim. Verify expired.")
      console.error("BTW: the furthest Q Dtx: ", furthestQDtx)

      console.warn("new target blockHeight for reClaiming: ", newTargetBlockHeight)
      console.warn("Current/prev blockHeight; ", currentBlockHeight)
      console.warn("Blocks from 'now' to renewal deadline: ", blocksBeforeRenewalDeadline)
      console.warn("Days from 'now' to renewal deadline: ", blocksBeforeRenewalDeadline / 144.0)

      console.error("\n\nBTW: this.props.blockHeight is " + this.props.blockHeight)
      console.error("  BUT, we'll use (reCLAIM at) blockHeight " + blockHeightForReclaiming)


      if ( blockHeightForReclaiming > this.props.blockHeight ) {
        const blocksInTheFuture = blockHeightForReclaiming - this.props.blockHeight
        const daysInTheFuture = blocksInTheFuture / 144.0
        alert("WHOOPS. We're getting ahead of ourselves. We have no more 'slack' (to build a quarterly for re-claiming) in domain " + domainToReclaim + "\n\n"
            + "We were trying to build a quarterly that's " + blocksInTheFuture + " blocks (" + daysInTheFuture + " days) in the FUTURE."
        )
        return
      }



      // state
      //    .newestSingleTx   txId we're about to build on
      //    .newestDtx        decoded tx we're about to build on
      //    .newestSingleDomain     for  .requestedDomain  
      //                                  and .ourIdentity
      //    this.state.baseContent + this.state.iteration     for .content: 
      this.setState({ newestSingleTx:         finalQTxId,
                      newestDtx:              furthestQDtx,   // <---
                      newestSingleDomain:     domainToReclaim,
                      iteration:              0,
                      baseContent:            'This should be our forced quarterly - a reCLAIM (by testerApp)',
                      blockHeightForReclaiming: blockHeightForReclaiming,
                    })
      await this.allowSetStateToRipple()

      const {keyUsedToClaim, newTx} = await attemptToClaim(window.shizzleContext,
                            domainToReclaim,

                            true, //this.state.found,

                            blockHeightForReclaiming, //this.state.blockHeightForReclaiming, //this.props.blockHeight,
                            finalQTxId, //this.state.finalQTxId,      //loopTxId,
                            JSON.stringify( furthestQDtx ), //this.state.furthestTxDecoded, //loopTxStr,     //Used by expressClaimFunc

                            domainToReclaim, //this.state.reachedLimb,       //loopTxLimbName,
                            0, //this.state.outputIndex,       //loopNextOutIdx,

                            furthestQDtx.outputStates[0].ownerCount+1, //this.state.newOwnerCount,
                            true, //this.state.owned,   <--- GOOD?
                            true, //this.state.expired,
                            false, // this.state.buildingOnModeP,   <----- GOOD?

                            this.state.privK,

                            this.claimCallbackPrepProgress,
                            this.claimCallbackBroadcastProgress,
                            this.claimFuncErrorCallback,
  //FIXME: empower forAFriend, and additionalBalance
                            false,  // for a friend
                            0,      // additional balance
                          )
      if ( newTx === null ) {
        alert("Tester APP testReclaiming() FAILED attemptToClaim() of " + domainToReclaim)
        return
      }

      console.warn("We THINK we managed to re-CLAIM  domain " + domainToReclaim)
      console.warn("  let's look at txid of : " + newTx)

      alert("Success at re-CLAIMing! ")
    } finally {
      this.updateWalletSummary
    }
  } // testReclaiming()

  async testInstaBuy() {
    boldLog("Running testInstaBuy() test")

    await this.maybeInitializeFundingParams()

    try {
      /*
      if ( HOLD_BACK_BLOCKHEIGHT_FOR_TESTING ) {
        alert("When testing Insta-BUY (any ownership-changing) features it's usually best to set 'HOLD_BACK_BLOCKHEIGHT_FOR_TESTING to false.\n\n" +
              "ABORTING test."
        )
        return
      }
      /** */

      const domainsToInstaBuy = await this.scanOldDomains()

      //FIXME: if there are none, then maybe CLAIM some?
      //       WELL, should advise user to first set HOLD_BACK_BLOCKHEIGHT_FOR_TESTING when claiming
      if ( domainsToInstaBuy.length === 0 ) {
        alert("There are no 'OLD' domains to test instaBuy :(")
        return
      }

      const finishCanceling = (parent) => {
        console.error("IMPLEMENT finishCanceling() for testInstaBuy()")
      }
      const doneFunc = (parent) => {
        console.error("IMPLEMENT doneFunc() for testInstaBuy()")
        shmalert("is this the same as processSearchResults()? prob not. Find out.")
      }

      const processSearchResults = async (txId,
                                          found, owned,
                                          status,
                                          finalQRes, latestPeriodicalRes=null, latestTransRes=null) => {
        console.error("processSearchResults() for testInstaBuy() call to findTipOfDomain()")

        console.warn("  status: ", status)          // want success (sorta. Eventually short-circuit to latest Q)
        console.warn("  txId: ", txId)              // EVENTUALLY we want this to be the latestQ
        console.warn("  found: ", found)
        console.warn("  owned: ", owned)
        console.warn("  FINAL Q: ", finalQRes)      // THIS, for now.   .status==='success', .txId

        if ( finalQRes.status !== 'success' ) {
          alert("Our seek to final Q (for instaBuy) wasn't 100% successful.\n\n\nFIXME: Take a closer look why not. <-----")
          return
        }

        console.error("We want to look at finalQ with txId of " + finalQRes.txId)

        // we do this so that we can access this info from the main thread
        // in parent function: testRenewal()
        this.setState({finalQTxId: finalQRes.txId})
        await this.allowSetStateToRipple()

      }  // inner processSearchResults()

      // At some point, maybe pick a RANDOM one?
      // PUT, ensure it CAN be renewed?
      const domainToInstaBuy = domainsToInstaBuy[ IDX_FOR_OLD_DOMAINS ]

      console.warn("ABOUT TO FIND TIP OF ", domainToInstaBuy)

      await findTipOfDomain(window.shizzleContext,
                            this,

                            this.props.blockHeight,   //NEW: to help reduce queries on
                                                      //     Quarterlies, and Periodicals

                            console.warn,             // progressFunc(string)
                            finishCanceling,
                            doneFunc,

                            domainToInstaBuy,          // target domain
                            processSearchResults,     // THIS is where we actually process the results

                            null,                     // 'visitTheGuestFunc' is only useful if we were tracking down the latest transient (which branch to follow)
                            () => {return false},     // don't worry about cancelling
                            null,                     //
                            true                      // Only bother finding the tip of the QUARTERLIES
                          )

      console.warn("We THINK we've got the latest Quarterly.  --->  finalQTxId: " + this.state.finalQTxId)

      const finalQTxId = this.state.finalQTxId

      if ( finalQTxId === null ) {
        console.warn("testInstaBuy(): skipping domain check. We have no valid quarterly")
        alert("can't InstaBuy? check console")
        return
      }

      const db = await openDB()

      const furthestQDtx = await queryFetchDecodeTx(window.shizzleContext, finalQTxId, db, true)
      console.error("Ok. furthestQDtx: ", furthestQDtx)



      // potentially helpful:
      //    .minBlockHeightForNextQuarterly    <----- use this to try renewing
      //    .furthestQuarterlyDtx    .outputStates[0]
      //                                  .blockNumInt
      //                                  .renewalDeadline
      //
      // MAYBE less helpful (IFF it's based on the ACTUAL, advanced, blockHeight)
      //    .expired
      //    .canBuildNewQuarterly
      //    .renewable
      //    .priceInSats
      //    .ownerP2PKH
      //    .potentialSaleFlag
      //    .potentialSaleMinBlock

      //TODO: MAYBE use a BOGUS blockheight when calling checkIfDomainExpiredOrRenewable() <------

      darkLog(" test of insta-BUY(): at tip. Will soon instaBUY...  ")

      const prevQuarterlyOutputState = furthestQDtx.outputStates[0]
      const currentBlockHeight = prevQuarterlyOutputState.blockNumInt  //quarterlyStats.currentQuarterlyBlockHeight
console.warn("NOTE: currentBlockHeight: ", currentBlockHeight)
      //let newTargetBlockHeight


      //const furthestQDtx = quarterlyStats.furthestQuarterlyDtx
      const newTargetBlockHeight = currentBlockHeight + 1  //FIXME: test with SAME bh too

      const blocksUntilRenewalDeadline = prevQuarterlyOutputState.renewalDeadlineInt - currentBlockHeight

      const blocksBeingAdded = newTargetBlockHeight - currentBlockHeight

      console.error("BTW: the furthest Q Dtx: ", furthestQDtx)

      console.warn("Current/prev blockHeight; ", currentBlockHeight)
      console.warn("   BTW: blocks (from prev/now) to renewal: " + blocksUntilRenewalDeadline +
                " (" + (blocksUntilRenewalDeadline/144.0) + " days)")

      console.warn("new target blockHeight for insta-buying: ", newTargetBlockHeight)

      console.warn("Blocks being added: ", blocksBeingAdded, " (" + (blocksBeingAdded/144.0) + " days)")

      console.error("\n\nBTW: this.props.blockHeight is " + this.props.blockHeight)



//alert("This next setSTate() might not even be needed. we're about to call claimAndPublishFunc(), NOT publishPost()")

      // state
      //    .newestSingleTx   txId we're about to build on
      //    .newestDtx        decoded tx we're about to build on
      //    .newestSingleDomain     for  .requestedDomain  
      //                                  and .ourIdentity
      //    this.state.baseContent + this.state.iteration     for .content: 
/*
      this.setState({ newestSingleTx:         finalQTxId,
                      newestDtx:              furthestQDtx,   // <---
                      newestSingleDomain:     domainToInstaBuy,
                      iteration:              0,
                      baseContent:            'This should be our forced quarterly - an instaBuy (by testerApp)',
                      //blockHeightForReclaiming: blockHeightForReclaiming,
                    })
      await this.allowSetStateToRipple()
*/





      // we installed an 'advancedParams' in claimAndPublishFunc()  - but not in attemptToClaim()
      const {keyUsedToClaim, newTx} = await claimAndPublishFunc(window.shizzleContext,
                            JSON.stringify(furthestQDtx), //furthestTxDecoded,
                            0, //outputIndex,
                            finalQTxId, //furthestTxId,
                            newTargetBlockHeight, //blockHeight,
                            false, //expired,
                            this.claimFuncErrorCallback, //cbClaimAndPublishError,

                            false, //forAFriend,
                            0, //optionalAdditionalBalance,

                            this.state.privK, //privK,

                            true,       //VERBOSE
                            {instaBuy: true}
                          )

      if ( newTx === null ) {
        alert("Tester APP testInstaBuy() FAILED claimAndPublishFunc() of " + domainToInstaBuy)
        return
      }

      console.warn("We THINK we managed to insta-BUY  domain " + domainToInstaBuy)
      console.warn("  let's look at txid of : " + newTx)


      const newQDtx = await queryFetchDecodeTx(window.shizzleContext, newTx, db, true)
      console.error("EXAMINE successful instalBUY newQDtx (note the outputStates[0].ownerCount, and QC): ", newQDtx)


      alert("Success at Insta-BUYING ! (check console for new ownerCount, and QC, and MODE")
    } finally {
      this.updateWalletSummary
    }
  } // testInstaBuy()


  // THESE next four will all use setupForBuildOfQuarterly

  async testRenewal() {

    boldLog("Running testRenewal() test")

  /*
    await this.maybeInitializeFundingParams()

    try {
      if ( !HOLD_BACK_BLOCKHEIGHT_FOR_TESTING ) {
        alert("When testing RENEWAL features it's usually best to set 'HOLD_BACK_BLOCKHEIGHT_FOR_TESTING to true.\n\n" +
              "ABORTING test."
        )
        return
      }

      const domainsToRenew = await this.scanOldDomains()

      if ( domainsToRenew.length === 0 ) {
        alert("There are no OLD domains to test renewing :(")
        return
      }

      alert("We're going to test renewing " + domainsToRenew.length + " OLD domains.")

      const finishCanceling = (parent) => {
        console.error("IMPLEMENT finishCanceling() for seekThenPost() call to findTipOfDomain()")
      }
      const doneFunc = (parent) => {
        console.error("IMPLEMENT doneFunc() for seekThenGuestPost() call to findTipOfDomain()")
        shmalert("is this the same as processSearchResults()? prob not. Find out.")
      }
      // I think this is too help decide WHICH transient to follow
      // It's not relevant for a search for the furthest QUARTERLY
      const visitTheGuestFunc = (guestLimb) => {
        return false
        const visitTheGuest = ourDomainFromWhichToPost === guestLimb
        console.error("visitTheGuestFunc() for seekThenGuestPost() call to findTipOfDomain()")
        return visitTheGuest
      }
      const processSearchResults = async (txId,
                                          found, owned,
                                          status,
                                          finalQRes, latestPeriodicalRes=null, latestTransRes=null) => {
        console.error("processSearchResults() for testRenewal() call to findTipOfDomain()")

        console.warn("  status: ", status)          // want success (sorta. Eventually short-circuit to latest Q)
        console.warn("  txId: ", txId)              // EVENTUALLY we want this to be the latestQ
        console.warn("  found: ", found)
        console.warn("  owned: ", owned)
        console.warn("  FINAL Q: ", finalQRes)      // THIS, for now.   .status==='success', .txId

        if ( finalQRes.status !== 'success' ) {
          alert("Our guest-post seek (somewhere) wasn't 100% successful.\n\n\nFIXME: Take a closer look why not. <-----")
          return
        }

        console.error("We want to look at finalQ with txId of " + finalQRes.txId)

        // we do this so that we can access this info from the main thread
        // in parent function: testRenewal()
        this.setState({finalQTxId: finalQRes.txId})
        await this.allowSetStateToRipple()

      }  // inner processSearchResults()


      // maybe pick a RANDOM one?
      // PUT, ensure it CAN be renewed?
      const domainToRenew = domainsToRenew[0].name

      console.warn("ABOUT TO FIND TIP OF ", domainToRenew)

      await findTipOfDomain(this,

                            this.props.blockHeight,   //NEW: to help reduce queries on
                                                      //     Quarterlies, and Periodicals

                            console.warn,             // progressFunc(string)
                            finishCanceling,
                            doneFunc,

                            domainToRenew, //target
                            processSearchResults,     // THIS is where we actually process the results

                            visitTheGuestFunc,        // useful if we were tracking down the latest transient (which branch to follow)
                            () => {return false},     // 
                            null,                     //
                            true                      // Only bother finding the tip of the QUARTERLIES
                          )

      console.warn("We THINK we've got the latest.  --->  finalQTxId: " + this.state.finalQTxId)

      const finalQTxId = this.state.finalQTxId

      if ( finalQTxId === null ) {
        console.warn("testRenewal(): skipping domain check. We have no valid quarterly")
        alert("can't renew? check console")
        return
      }

      const db = await openDB()

      const quarterlyStats = await checkIfDomainExpiredOrRenewable(db, finalQTxId, this.props.blockHeight)

      //console.log("testRenewal(): quarterlyStats: ", quarterlyStats)
      //console.log("testRenewal(): qs.furthestQuarterlyDtx: ", quarterlyStats.furthestQuarterlyDtx)
      //console.log("testRenewal(): qs.furthestQuarterlyDtx.limbName: ", quarterlyStats.furthestQuarterlyDtx.limbName)

      console.error("furthest QStats of " + domainToRenew + " (at txId " + finalQTxId + "):", quarterlyStats)

      //const finalQDtx = await queryFetchDecodeTx(window.shizzleContext, finalQTxId, db, false)
      //console.error("finalQ of " + domainToRenew + ":", finalQDtx)
      //alert("We THINK we're done with testRenewal - BUT, we actually need to USE/examine state from processSearchResults()")


      // potentially helpful:
      //    .minBlockHeightForNextQuarterly    <----- use this to try renewing
      //    .furthestQuarterlyDtx    .outputStates[0]
      //                                  .blockNumInt
      //                                  .renewalDeadline
      //
      // MAYBE less helpful (IFF it's based on the ACTUAL, advanced, blockHeight)
      //    .expired
      //    .canBuildNewQuarterly
      //    .renewable
      //    .priceInSats
      //    .ownerP2PKH
      //    .potentialSaleFlag
      //    .potentialSaleMinBlock

      //TODO: MAYBE use a BOGUS blockheight when calling checkIfDomainExpiredOrRenewable() <------

      const furthestQDtx = quarterlyStats.furthestQuarterlyDtx
      const newTargetBlockHeight = furthestQDtx.outputStates[0].renewalDeadlineInt
      const currentBlockHeight = quarterlyStats.currentQuarterlyBlockHeight

      const blocksBeforeRenewalDeadline = newTargetBlockHeight - currentBlockHeight

      const blockHeightForRenewal = newTargetBlockHeight - 100  //FIXME: should make sure it's not in the past

      console.error("BTW: the furthest Q Dtx: ", furthestQDtx)

      console.warn("new target blockHeight for renewal: ", newTargetBlockHeight)
      console.warn("Current/prev blockHeight; ", currentBlockHeight)
      console.warn("Blocks from 'now' to renewal deadline: ", blocksBeforeRenewalDeadline)
      console.warn("Days from 'now' to renewal deadline: ", blocksBeforeRenewalDeadline / 144.0)

      console.error("\n\nBTW: this.props.blockHeight is " + this.props.blockHeight)
      console.error("  BUT, we'll use (renew at) blockHeight " + blockHeightForRenewal)

      // state
      //    .newestSingleTx   txId we're about to build on
      //    .newestDtx        decoded tx we're about to build on
      //    .newestSingleDomain     for  .requestedDomain  
      //                                  and .ourIdentity
      //    this.state.baseContent + this.state.iteration     for .content: 
      this.setState({ newestSingleTx:         finalQTxId,
                      newestDtx:              furthestQDtx,   // <---
                      newestSingleDomain:     domainToRenew,
                      iteration:              0,
                      baseContent:            'This should be our forced quarterly - a renewal (by testerApp)',
                      blockHeightForRenewing: blockHeightForRenewal,
                    })
      await this.allowSetStateToRipple()

      const finalProcessing = () => {}
      const success = await publishPost('forceQuarterly',
                                        false, null, null, null, null,  // guest params not relevant
                                        finalProcessing,
                                        this.contextFuncForRenewing,
                                        this.milestoneFuncForPosting, // and renewing
                                        this.errorFuncForPosting)     // and renewing

      console.warn("We TRIED to build a quarterly. success? " + success)
      console.warn("  let's look at txid of (state.newestSingleTx): " + this.state.newestSingleTx)
      console.warn("  let's look at tx   of (state.newestDtx): " + this.state.newestDtx)
      console.warn("  and .iteration is " + this.state.iteration)

      if ( success ) {
        alert("It's possible that we SUCCEEDED in renewing " + domainToInstaSell)
      } else {
        alert("We thinkg we FAILED to renew domain " + domainToInstaSell)
      }

    } finally {
      this.updateWalletSummary
    }
  */
    const {success, domain} = await this.setupForBuildOfQuarterly('renewal', this.contextFuncForRenewing)

    if ( success ) {
      alert("We think we SUCCEEDED in renewing domain " + domain)
    } else {
      alert("We think we FAILED to renew domain " + domain)
    }

  } //testRenewal()
  
  async testInstaOffer() {

    boldLog("Running testInstaOffer() test")

    const {success, domain} = await this.setupForBuildOfQuarterly('offer', this.contextFuncForInstaOffer, 9000)

    if ( success ) {

      console.warn("testInstaOffer(): newestSingleTx: " + this.state.newestSingleTx)
      console.warn("                  let's check if it ACTUALLY set a price. state.newestDtx: ", this.state.newestDtx)

      alert("We **think** we SUCCEEDED in setting a price for domain " + domain + "\n\n"
          + "BUT, we should actually check the .price in the outputStates[0]"
      )
    } else {
      alert("We think we FAILED to set a price for domain " + domain)
    }
  }

  async testBuildNextQuarterly() {

    boldLog("Running testBuildNextQuarterly() test")

    const {success, domain}  = await this.setupForBuildOfQuarterly('nextQ', this.contextFuncForSimpleBuild)

    if ( success ) {
      console.warn("testBuildNextQuarterly(): newestSingleTx: " + this.state.newestSingleTx)
      console.warn("                          let's check the .quarterlyCount of state.newestDtx: ", this.state.newestDtx)

      alert("We think we SUCCEEDED in building a QUARTERLY for domain " + domain + "\n\n" +
            "BUT, we should check the new QC (in the console)")
    } else {
      alert("We think we FAILED to build a QUARTERLY for domain " + domain)
    }
  }

  async testBuildNextPeriodical() {

    boldLog("Running testBuildNextPeriodical() test")

    const {success, domain}  = await this.setupForBuildOfPeriodical('nextQ', this.contextFuncForSimpleBuild)

    if ( success ) {
      console.warn("testBuildNextPeriodical(): newestSingleTx: " + this.state.newestSingleTx)
      console.warn("                          let's check the .periodicCount of state.newestDtx: ", this.state.newestDtx)

      alert("We think we SUCCEEDED in building a PERIODICAL for domain " + domain + "\n\n" +
            "BUT, we should check the new PC (in the console)")
    } else {
      alert("We think we FAILED to build a PERIODICAL for domain " + domain)
    }
  }

  async setupForBuildOfQuarterly(op, contextFunc = null, price = 0) {

    await this.maybeInitializeFundingParams()

    if ( contextFunc === null ) {
      alert("CODE ERROR: we need a contextFunc to setup for building a quarterly")
      return {
        success: false,
        domain: null
       } 
    }

    try {
      alert("setupForBuildOfQuarterly   (op: " + op + ")")

      if ( !HOLD_BACK_BLOCKHEIGHT_FOR_TESTING ) {
        alert("When testing features which build a quarterly (but NOT claiming) it's usually best to set 'HOLD_BACK_BLOCKHEIGHT_FOR_TESTING to true.\n\n" +
              "ABORTING test."
        )
        return {
                success: false,
                domain: null
               } 
      }

      const domainsToBuildOn = await this.scanOldDomains()
console.error("setupForBuildOfQ(): domainsToBuildOn: ", domainsToBuildOn)

      if ( domainsToBuildOn.length === 0 ) {
        alert("There are no OLD domains to test QC-building :(")
        return {
                  success: false,
                  domain: null
               } 
      }

      alert("We're going to test building a Q for one of " + domainsToBuildOn.length + " OLD domains.")

      const finishCanceling = (parent) => {
        console.error("IMPLEMENT finishCanceling() for setupForBuildOfQuarterly() call to findTipOfDomain()")
      }
      const doneFunc = (parent) => {
        console.error("IMPLEMENT doneFunc() for setupForBuildOfQuarterly() call to findTipOfDomain()")
        shmalert("is this the same as processSearchResults()? prob not. Find out.")
      }
      const processSearchResults = async (txId,
                                          found, owned,
                                          status,
                                          finalQRes, latestPeriodicalRes=null, latestTransRes=null) => {
        console.error("processSearchResults() for setupForBuildOfQuarterly() call to findTipOfDomain()")

        console.warn("  status: ", status)          // want success (sorta. Eventually short-circuit to latest Q)
        console.warn("  txId: ", txId)              // EVENTUALLY we want this to be the latestQ
        console.warn("  found: ", found)
        console.warn("  owned: ", owned)
        console.warn("  FINAL Q: ", finalQRes)      // THIS, for now.   .status==='success', .txId

        if ( finalQRes.status !== 'success' ) {
          alert("Our q-seek (somewhere) wasn't 100% successful.\n\n\nFIXME: Take a closer look why not. <-----")
          return

          //FIXME: return some kind of FAILure?
        }

        console.error("We want to look at finalQ with txId of " + finalQRes.txId)

        // we do this so that we can access this info from the main thread
        // in parent function: testRenewal()
        this.setState({finalQTxId: finalQRes.txId})
        await this.allowSetStateToRipple()

      }  // inner processSearchResults()


      // maybe pick a RANDOM one?
      // PUT, ensure it CAN be renewed?
      const domainToBuildQon = domainsToBuildOn[ IDX_FOR_OLD_DOMAINS ]

      console.warn("ABOUT TO FIND TIP OF ", domainToBuildQon)

      await findTipOfDomain(window.shizzleContext,
                            this,

                            this.props.blockHeight,   //NEW: to help reduce queries on
                                                      //     Quarterlies, and Periodicals

                            console.warn,             // progressFunc(string)
                            finishCanceling,
                            doneFunc,

                            domainToBuildQon, //target
                            processSearchResults,     // THIS is where we actually process the results

                            () => {return false},     // visitTheGuestFunc() only useful if we were tracking down the latest transient (which branch to follow)
                            () => {return false},     // don't allow canceling
                            null,                     //
                            true                      // Only bother finding the tip of the QUARTERLIES
                          )

      console.warn("We THINK we've got the latest.  --->  finalQTxId: " + this.state.finalQTxId)

      const finalQTxId = this.state.finalQTxId

      if ( finalQTxId === null ) {
        console.warn("setupForBuildOfQuarterly(): skipping domain check. We have no valid quarterly")
        alert("can't build a Q here? check console")
        return {
                  success: false,
                  domain: domainToBuildQon
               } 
      }

      const db = await openDB()

      const furthestQDtx = await queryFetchDecodeTx(window.shizzleContext, finalQTxId, db, true)
console.error("YAY furthestQDtx: ", furthestQDtx)

      //console.log("testRenewal(): quarterlyStats: ", quarterlyStats)
      //console.log("testRenewal(): qs.furthestQuarterlyDtx: ", quarterlyStats.furthestQuarterlyDtx)
      //console.log("testRenewal(): qs.furthestQuarterlyDtx.limbName: ", quarterlyStats.furthestQuarterlyDtx.limbName)


      //const finalQDtx = await queryFetchDecodeTx(window.shizzleContext, finalQTxId, db, false)
      //console.error("finalQ of " + domainToRenew + ":", finalQDtx)
      //alert("We THINK we're done with testRenewal - BUT, we actually need to USE/examine state from processSearchResults()")


      // potentially helpful:
      //    .minBlockHeightForNextQuarterly    <----- use this to try renewing
      //    .furthestQuarterlyDtx    .outputStates[0]
      //                                  .blockNumInt
      //                                  .renewalDeadline
      //
      // MAYBE less helpful (IFF it's based on the ACTUAL, advanced, blockHeight)
      //    .expired
      //    .canBuildNewQuarterly
      //    .renewable
      //    .priceInSats
      //    .ownerP2PKH
      //    .potentialSaleFlag
      //    .potentialSaleMinBlock

      //TODO: MAYBE use a BOGUS blockheight when calling checkIfDomainExpiredOrRenewable() <------

      //const furthestQDtx = quarterlyStats.furthestQuarterlyDtx

      darkLog(" setupForBuildOfQ(): at tip of " + domainToBuildQon + ". Will soon publish new Q")

      const prevQuarterlyOutputState = furthestQDtx.outputStates[0]
      const currentBlockHeight = prevQuarterlyOutputState.blockNumInt  //quarterlyStats.currentQuarterlyBlockHeight
console.warn("NOTE: currentBlockHeight: ", currentBlockHeight)

      let newTargetBlockHeight
      if ( op === 'renewal' ) {
        newTargetBlockHeight = prevQuarterlyOutputState.renewalDeadlineInt - 100
        console.warn("using op renewal")
      } else if ( op === 'nextQ' ) { // instaOffer
        newTargetBlockHeight = currentBlockHeight + FOURTH_OF_YEAR_IN_BLOCKS
        console.warn("using op nextQ")
      } else if ( op === 'offer' ) {
        if ( prevQuarterlyOutputState.quarterlyCount < 6 ) {
          alert("PROBLEM: it's too early to set a price for this asset. Its QC must be at least 6, but it's currently " + prevQuarterlyOutputState.quarterlyCount)

          if ( confirm("Would you like to just build a 'regular' quarterly for now?") ) {
            price = 0
            alert("NOTE: we're not sure if the contextFunc (for insta) is appropriate for normal Q building...\n\nWe COULD just substitute it HERE.")
          } else {
            alert("Fine. ABORTING setting of price")
            return {
              success: false,
              domain: domainToBuildQon
            }
          }
        }
        newTargetBlockHeight = prevQuarterlyOutputState.renewalDeadlineInt - 100
        console.warn("using op 'offer'")
      }

      const blocksUntilRenewalDeadline = prevQuarterlyOutputState.renewalDeadlineInt - currentBlockHeight


      const blocksBeingAdded = newTargetBlockHeight - currentBlockHeight

      console.error("BTW: the furthest Q Dtx: ", furthestQDtx)

      console.warn("Current/prev blockHeight; ", currentBlockHeight)
      console.warn("   BTW: blocks (from prev/now) to renewal: " + blocksUntilRenewalDeadline +
                " (" + (blocksUntilRenewalDeadline/144.0) + " days)")

      console.warn("new target blockHeight for operation: ", newTargetBlockHeight)

      console.warn("Blocks being added: ", blocksBeingAdded, " (" + (blocksBeingAdded/144.0) + " days)")

      console.error("\n\nBTW: this.props.blockHeight is " + this.props.blockHeight)


//alert("Q OP: can/should we verify it's NOT expired?    (domain: " + domainToBuildQon + ")")


const quarterlyStats = await checkIfDomainExpiredOrRenewable(db, finalQTxId, newTargetBlockHeight) //this.props.blockHeight)
console.error("furthest QStats of " + domainToBuildQon + " (txId " + finalQTxId + ") at TARGET blockHeight of " + newTargetBlockHeight + ":", quarterlyStats)
console.error("NOTE: qstats.renewable: " + quarterlyStats.renewable)


      if ( newTargetBlockHeight > this.props.blockHeight ) {
        const blocksInTheFuture = newTargetBlockHeight - this.props.blockHeight
        const daysInTheFuture = blocksInTheFuture / 144.0
        alert("WHOOPS. We're getting ahead of ourselves. We have no more 'slack' (to build quarterlies) in domain " + domainToBuildQon + "\n\n"
            + "We were trying to build a quarterly that's " + blocksInTheFuture + " blocks (" + daysInTheFuture + " days) in the FUTURE."
        )
        return {
          success: false,
          domain: domainToBuildQon
        } 
      }

      // state
      //    .newestSingleTx   txId we're about to build on
      //    .newestDtx        decoded tx we're about to build on
      //    .newestSingleDomain     for  .requestedDomain  
      //                                  and .ourIdentity
      //    this.state.baseContent + this.state.iteration     for .content: 
      this.setState({ newestSingleTx:         finalQTxId,
                      newestDtx:              furthestQDtx,   // <---
                      newestSingleDomain:     domainToBuildQon,
                      iteration:              0,
                      baseContent:            'This should be our forced quarterly (by testerApp)',
                      blockHeightForQ:        newTargetBlockHeight,

                      priceToSell:            price,
                      qStats:                 quarterlyStats,
                    })
      await this.allowSetStateToRipple()

      const finalProcessing = () => {}

      const success = await publishPost(window.shizzleContext,
                                        'forceQuarterly',
                                        false, null, null, null, null,  // guest params not relevant
                                        finalProcessing,
                                        contextFunc,                    // specific for renewal, or instaOffer
                                        this.milestoneFuncForPosting, // and renewing, and insta-selling
                                        this.errorFuncForPosting)     // and renewing

      console.warn("We TRIED to build a quarterly. success? " + success)
      console.warn("  let's look at txid of (state.newestSingleTx): " + this.state.newestSingleTx)
      console.warn("  let's look at tx   of (state.newestDtx): ", this.state.newestDtx)
      console.warn("  and .iteration is " + this.state.iteration)


//FIXME: soon: have an explicit op: 'offer', or 'ask', or instaOffer, or whatever
      if ( price > 0 ) {
        if ( this.state.newestDtx.outputStates[0].priceInSatsDecimal !== price ) {
          console.log("newestDtx: ", this.state.newestDtx)
          alert("SOMETHING WENT WRONG with setting the insta-price (ask)). EXAMINE the decoded tx.  txid: " + this.state.newestSingleTx)
          return
        } else {
          alert("We've verified the instaPrice was correctly set: " + price + " sats")
        }
      }

      return {
              success: success,
              domain: domainToBuildQon
             } 

    } finally {
      this.updateWalletSummary
    }
  }

  async setupForBuildOfPeriodical(op, contextFunc = null) {

    await this.maybeInitializeFundingParams()

    if ( contextFunc === null ) {
      alert("CODE ERROR: we need a contextFunc to setup for building a periodical")
      return {
        success: false,
        domain: null
       } 
    }

    try {
      alert("setupForBuildOfPeriodical   (op: " + op + ")")

      if ( !HOLD_BACK_BLOCKHEIGHT_FOR_TESTING ) {
        alert("When testing features which build a periodical it's usually best to set 'HOLD_BACK_BLOCKHEIGHT_FOR_TESTING to true.\n\n" +
              "ABORTING test."
        )
        return {
                success: false,
                domain: null
               } 
      }

      const domainsToBuildOn = await this.scanOldDomains()
console.error("setupForBuildOfP(): domainsToBuildOn: ", domainsToBuildOn)

      if ( domainsToBuildOn.length === 0 ) {
        alert("There are no OLD domains to test PC-building :(")
        return {
                  success: false,
                  domain: null
               } 
      }

      alert("We're going to test building a Periodical for one of " + domainsToBuildOn.length + " OLD domains.")

      const finishCanceling = (parent) => {
        console.error("IMPLEMENT finishCanceling() for setupForBuildOfPeriodical() call to findTipOfDomain()")
      }
      const doneFunc = (parent) => {
        console.error("IMPLEMENT doneFunc() for setupForBuildOfPeriodical() call to findTipOfDomain()")
        shmalert("is this the same as processSearchResults()? prob not. Find out.")
      }
      const processSearchResults = async (txId,         //furthest
                                          found, owned,
                                          status,
                                          finalPRes, latestPeriodicalRes=null, latestTransRes=null) => {
        console.error("processSearchResults() for setupForBuildOfPeriodical() call to findTipOfDomain()")

        console.warn("  status: ", status)          // want success (sorta. Eventually short-circuit to latest Q)
        console.warn("  txId: ", txId)              // EVENTUALLY we want this to be the latestQ
        console.warn("  found: ", found)
        console.warn("  owned: ", owned)
        console.warn("  FINAL P: ", finalPRes)      // THIS, for now.   .status==='success', .txId

        if ( finalPRes.status === 'done' ) {
          console.error("finalPRes: ", finalPRes)
          console.error("latestPeriodicalRes: ", latestPeriodicalRes)

          console.error("It's possible there's no PERIODICAL, and we'd need to build a new QUARTERLY that SPAWNS a PERIODICAL")

          alert("APPLY NEW LOGIC HERE")
        } else if ( finalPRes.status !== 'success' ) {
          console.error("finalPRes: ", finalPRes)
          console.error("latestPeriodicalRes: ", latestPeriodicalRes)
          alert("Our periodical-seek (somewhere) wasn't 100% successful.\n\n\nFIXME: Take a closer look why not. <-----")
          return

          //FIXME: return some kind of FAILure?
        }

        console.error("We want to look at finalPeriodical with txId of " + finalPRes.txId)

        // we do this so that we can access this info from the main thread
        // in parent function: testRenewal()
        this.setState({finalPTxId: finalPRes.txId})
        await this.allowSetStateToRipple()

      }  // inner processSearchResults()


      // maybe pick a RANDOM one?
      // PUT, ensure it CAN be renewed?
      const domainToBuildPon = domainsToBuildOn[ IDX_FOR_OLD_DOMAINS ]

      console.warn("ABOUT TO FIND TIP OF ", domainToBuildPon)

      await findTipOfDomain(window.shizzleContext,
                            this,

                            this.props.blockHeight,   //NEW: to help reduce queries on
                                                      //     Quarterlies, and Periodicals

                            console.warn,             // progressFunc(string)
                            finishCanceling,
                            doneFunc,

                            domainToBuildPon,         //target
                            processSearchResults,     // THIS is where we actually process the results (set state for finalPTxId)

                            () => {return false},     // visitTheGuestFunc() only useful if we were tracking down the latest transient (which branch to follow)
                            () => {return false},     // don't allow canceling
                            null,                     //
                            false,                    // NOT looking for final quarterly
                            true,                     // Loooking for the final PERIODICAL (or, where it could be BUILT)
                          )

      console.warn("We THINK we've got the latest.  --->  finalPTxId: " + this.state.finalPTxId)

      const finalPTxId = this.state.finalPTxId

      if ( finalPTxId === null ) {
        console.warn("setupForBuildOfPeriodical(): skipping domain check. We have no valid periodical")
        alert("can't build a P here? check console. MAYBE we need to build a new Q, and spawn a Periodical? TBD")
        return {
                  success: false,
                  domain: domainToBuildPon
               } 
      }

      const db = await openDB()

      const furthestPDtx = await queryFetchDecodeTx(window.shizzleContext, finalPTxId, db, true)
console.error("YAY furthestPDtx: ", furthestPDtx)

      //console.log("testRenewal(): quarterlyStats: ", quarterlyStats)
      //console.log("testRenewal(): qs.furthestQuarterlyDtx: ", quarterlyStats.furthestQuarterlyDtx)
      //console.log("testRenewal(): qs.furthestQuarterlyDtx.limbName: ", quarterlyStats.furthestQuarterlyDtx.limbName)


      //const finalQDtx = await queryFetchDecodeTx(window.shizzleContext, finalQTxId, db, false)
      //console.error("finalQ of " + domainToRenew + ":", finalQDtx)
      //alert("We THINK we're done with testRenewal - BUT, we actually need to USE/examine state from processSearchResults()")


      // potentially helpful:
      //    .minBlockHeightForNextQuarterly    <----- use this to try renewing
      //    .furthestQuarterlyDtx    .outputStates[0]
      //                                  .blockNumInt
      //                                  .renewalDeadline
      //
      // MAYBE less helpful (IFF it's based on the ACTUAL, advanced, blockHeight)
      //    .expired
      //    .canBuildNewQuarterly
      //    .renewable
      //    .priceInSats
      //    .ownerP2PKH
      //    .potentialSaleFlag
      //    .potentialSaleMinBlock

      //TODO: MAYBE use a BOGUS blockheight when calling checkIfDomainExpiredOrRenewable() <------

      //const furthestQDtx = quarterlyStats.furthestQuarterlyDtx

      darkLog(" setupForBuildOfP(): at tip of " + domainToBuildPon + ". Will soon publish new Periodical")

      const prevPeriodicalOutputState = furthestPDtx.outputStates[0]
      const currentBlockHeight = prevPeriodicalOutputState.blockNumInt  //quarterlyStats.currentQuarterlyBlockHeight
console.warn("NOTE: currentBlockHeight: ", currentBlockHeight)

      let newTargetBlockHeight = currentBlockHeight + FOURTH_OF_YEAR_IN_BLOCKS
      console.warn("using op nextQ")

      if ( prevPeriodicalOutputState.quarterlyCount < 6 ) {
        alert("PROBLEM: it's too early to set a price for this asset. Its QC must be at least 6, but it's currently " + prevPeriodicalOutputState.periodicCount)

      }

alert("FIXME: is there something we can check to not EXCEED max updates?")

      const blocksBeingAdded = newTargetBlockHeight - currentBlockHeight

      console.error("BTW: the furthest Periodical Dtx: ", furthestPDtx)

      console.warn("Current/prev blockHeight; ", currentBlockHeight)


      console.warn("new target blockHeight for operation: ", newTargetBlockHeight)

      console.warn("Blocks being added: ", blocksBeingAdded, " (" + (blocksBeingAdded/144.0) + " days)")

      console.error("\n\nBTW: this.props.blockHeight is " + this.props.blockHeight)


//alert("Q OP: can/should we verify it's NOT expired?    (domain: " + domainToBuildQon + ")")


alert("Do we want an analogous function: checkIfPeriodicalsDoneOrReclaimable() ?")
//const quarterlyStats = await checkIfDomainExpiredOrRenewable(db, finalPTxId, newTargetBlockHeight) //this.props.blockHeight)
console.error("furthest PStats of " + domainToBuildPon + " (txId " + finalPTxId + ") at TARGET blockHeight of " + newTargetBlockHeight + ":", quarterlyStats)
//console.error("NOTE: qstats.renewable: " + quarterlyStats.renewable)

throw new Error("need to finish implementing setupForBuildOfPeriodical()")

alert("Change logic below to check for slack in PERIODICALS? Generally, it's easier to have slack there, than for Quarterlies.")

      if ( newTargetBlockHeight > this.props.blockHeight ) {
        const blocksInTheFuture = newTargetBlockHeight - this.props.blockHeight
        const daysInTheFuture = blocksInTheFuture / 144.0
        alert("WHOOPS. We're getting ahead of ourselves. We have no more 'slack' (to build Periodicals) in domain " + domainToBuildPon + ". BUT for WHICH OWNER?\n\n"
            + "We were trying to build a periodical that's " + blocksInTheFuture + " blocks (" + daysInTheFuture + " days) in the FUTURE."
        )
        return {
          success: false,
          domain: domainToBuildPon
        } 
      }

      // state
      //    .newestSingleTx   txId we're about to build on
      //    .newestDtx        decoded tx we're about to build on
      //    .newestSingleDomain     for  .requestedDomain  
      //                                  and .ourIdentity
      //    this.state.baseContent + this.state.iteration     for .content: 
      this.setState({ newestSingleTx:         finalPTxId,
                      newestDtx:              furthestPDtx,   // <---
                      newestSingleDomain:     domainToBuildPon,
                      iteration:              0,
                      baseContent:            'This should be our forced periodical (by testerApp)',
                      blockHeightForQ:        newTargetBlockHeight,

                      priceToSell:            price,
                      //pStats:                 periodicalStats,
                    })
      await this.allowSetStateToRipple()

      const finalProcessing = () => {}

alert("Do we HAVE, or NEED a publishPost() 'forcePeriodical' mode?")
      const success = await publishPost(window.shizzleContext,
                                        'forceQuarterly',
                                        false, null, null, null, null,  // guest params not relevant
                                        finalProcessing,
                                        contextFunc,                    // specific for renewal, or instaOffer
                                        this.milestoneFuncForPosting, // and renewing, and insta-selling
                                        this.errorFuncForPosting)     // and renewing

      console.warn("We TRIED to force-build a PERIODICAL. success? " + success)
      console.warn("  let's look at txid of (state.newestSingleTx): " + this.state.newestSingleTx)
      console.warn("  let's look at tx   of (state.newestDtx): ", this.state.newestDtx)
      console.warn("  and .iteration is " + this.state.iteration)

      return {
              success: success,
              domain: domainToBuildPon
             } 

    } finally {
      this.updateWalletSummary
    }
  }

  //FIXME: rename potentialAsk()?
  async testPotentialOffer() {

    const offerPrice = 1050
    boldLog("Running testPotentialOffer() test")

    await this.maybeInitializeFundingParams()

    try {
      alert("IMPLEMENT testPotentialOFFER" +
            "\n\nblockHeight in some zone. OWNER opens POTENTIAL SALE state (via a special Q?)." +
            "\n\nDO: identify all edges (4?)"
      )







      const domainsToPotentialOffer = await this.scanOldDomains()

      //FIXME: if there are none, then maybe CLAIM some?
      //       WELL, should advise user to first set HOLD_BACK_BLOCKHEIGHT_FOR_TESTING when claiming
      if ( domainsToPotentialOffer.length === 0 ) {
        alert("There are no 'OLD' domains to test setting potential OFFER :(")
        return
      }

      const finishCanceling = (parent) => {
        console.error("IMPLEMENT finishCanceling() for testPotentialOffer()")
      }
      const doneFunc = (parent) => {
        console.error("IMPLEMENT doneFunc() for testPotentialOffer()")
        shmalert("is this the same as processSearchResults()? prob not. Find out.")
      }

      const processSearchResults = async (txId,
                                          found, owned,
                                          status,
                                          finalQRes, latestPeriodicalRes=null, latestTransRes=null) => {
        console.error("processSearchResults() for testPotentialOffer() call to findTipOfDomain()")

        console.warn("  status: ", status)          // want success (sorta. Eventually short-circuit to latest Q)
        console.warn("  txId: ", txId)              // EVENTUALLY we want this to be the latestQ
        console.warn("  found: ", found)
        console.warn("  owned: ", owned)
        console.warn("  FINAL Q: ", finalQRes)      // THIS, for now.   .status==='success', .txId

        if ( finalQRes.status !== 'success' ) {
          alert("Our seek to final Q (for setting potential offer) wasn't 100% successful.\n\n\nFIXME: Take a closer look why not. <-----")
          return
        }

        console.error("We want to look at finalQ with txId of " + finalQRes.txId)

        // we do this so that we can access this info from the main thread
        // in parent function: testRenewal()
        this.setState({finalQTxId: finalQRes.txId})
        await this.allowSetStateToRipple()

      }  // inner processSearchResults()

      // At some point, maybe pick a RANDOM one?
      // PUT, ensure it CAN be renewed?
      const domainToSetOffer = domainsToPotentialOffer[ IDX_FOR_OLD_DOMAINS ]

      console.warn("ABOUT TO FIND TIP OF ", domainToSetOffer)

      await findTipOfDomain(window.shizzleContext,
                            this,

                            this.props.blockHeight,   //NEW: to help reduce queries on
                                                      //     Quarterlies, and Periodicals

                            console.warn,             // progressFunc(string)
                            finishCanceling,
                            doneFunc,

                            domainToSetOffer,          // target domain
                            processSearchResults,     // THIS is where we actually process the results

                            null,                     // 'visitTheGuestFunc' is only useful if we were tracking down the latest transient (which branch to follow)
                            () => {return false},     // don't worry about cancelling
                            null,                     //
                            true                      // Only bother finding the tip of the QUARTERLIES
                          )

      console.warn("We THINK we've got the latest Quarterly.  --->  finalQTxId: " + this.state.finalQTxId)

      const finalQTxId = this.state.finalQTxId

      if ( finalQTxId === null ) {
        console.warn("testPotentialOffer(): skipping domain check. We have no valid quarterly")
        alert("can't potentialOffer? check console")
        return
      }

      const db = await openDB()

      const furthestQDtx = await queryFetchDecodeTx(window.shizzleContext, finalQTxId, db, true)
      console.error("Ok. furthestQDtx: ", furthestQDtx)



      // potentially helpful:
      //    .minBlockHeightForNextQuarterly    <----- use this to try renewing
      //    .furthestQuarterlyDtx    .outputStates[0]
      //                                  .blockNumInt
      //                                  .renewalDeadline
      //
      // MAYBE less helpful (IFF it's based on the ACTUAL, advanced, blockHeight)
      //    .expired
      //    .canBuildNewQuarterly
      //    .renewable
      //    .priceInSats
      //    .ownerP2PKH
      //    .potentialSaleFlag
      //    .potentialSaleMinBlock

      //TODO: MAYBE use a BOGUS blockheight when calling checkIfDomainExpiredOrRenewable() <------

      darkLog(" test of testPotentialOffer(): at tip. Will soon SET params of OFFER...  ")

      const prevQuarterlyOutputState = furthestQDtx.outputStates[0]
      const currentBlockHeight = prevQuarterlyOutputState.blockNumInt  //quarterlyStats.currentQuarterlyBlockHeight
console.warn("NOTE: currentBlockHeight: ", currentBlockHeight)




      const newTargetBlockHeight = currentBlockHeight + 1  //FIXME: test with SAME bh too

      const blocksUntilRenewalDeadline = prevQuarterlyOutputState.renewalDeadlineInt - currentBlockHeight

      const blocksBeingAdded = newTargetBlockHeight - currentBlockHeight

      console.error("BTW: the furthest Q Dtx: ", furthestQDtx)

      console.warn("AGAIN: Current/prev blockHeight; ", currentBlockHeight)
      console.warn("   BTW: blocks (from prev/now) to renewal: " + blocksUntilRenewalDeadline +
                " (" + (blocksUntilRenewalDeadline/144.0) + " days)")

      console.warn("new target blockHeight for SETTING params of OFFER: ", newTargetBlockHeight)

      console.warn("Blocks being added: ", blocksBeingAdded, " (" + (blocksBeingAdded/144.0) + " days)")

      console.error("\n\nBTW: this.props.blockHeight is " + this.props.blockHeight)


      console.warn("props.bundle: ", this.props.bundle)

      const pubKeyX = bsv.PublicKey.fromPrivateKey( bsv.PrivateKey.fromString(this.props.bundle.p) )
      console.log("derived seller pubKey: ", pubKeyX.toString())
      const derivedSellerP2PKH = bsv.crypto.Hash.sha256ripemd160(pubKeyX.toBuffer('hex')).toString('hex')
      console.log("Derived seller p2pkh: ", derivedSellerP2PKH, '\n');
      if ( derivedSellerP2PKH.length !== 40 ) {
        alert("trouble deriving owner/seller p2pkh")
        throw new Error("invalid p2pkh")
      }



      //const payoutAddressEntry = await allocateAvailableAddress(db)
      const rabinPkhOfBuyer = await allocateAvailableRabin(db)
console.error("\n\n rabin of buyer: ", rabinPkhOfBuyer)

      //FIXME: maybe better place to do this? meh
      //FIXME: 
console.error("this.props.bundle: ", this.props.bundle)
      const {rabinPrivKeyP, rabinPrivKeyQ, error}
                   = await getRabinPrivs(db, prevQuarterlyOutputState.ownerRabinPKH, this.props.bundle.pwd, "testerAPP testPotentialOffer")
      if ( error !== null ) {
          console.error("ERROR retrieving rabin priv keys: ", error)
          throw new Error("trouble retrieving owner rabin priv keys")
          //alert("error: read console ")
          //errorFunc(304, nameToClaim)
          //return {rabinPKH: prevRabinPKH}
      }


      // we installed an 'advancedParams' in claimAndPublishFunc()  - but not in attemptToClaim()
      const {keyUsedToClaim, newTx} = await claimAndPublishFunc(window.shizzleContext,
                            JSON.stringify(furthestQDtx), //furthestTxDecoded,
                            0, //outputIndex,
                            finalQTxId, //furthestTxId,
                            newTargetBlockHeight, //blockHeight,
                            false, //expired,
                            this.claimFuncErrorCallback, //cbClaimAndPublishError,

                            false, //forAFriend,
                            0, //optionalAdditionalBalance,

                            this.state.privK, //privK,

                            true,       //VERBOSE
                            {
                              rabinPkhOfPotentialBuyer: rabinPkhOfBuyer[0].pkh,
                              agreedPriceInSats: offerPrice,
                              ownerP2PKH: derivedSellerP2PKH,
                              // potentialSalesFlag,
                              // potentialSaleMinBlock
                              rabinPrivP: rabinPrivKeyP,
                              rabinPrivQ: rabinPrivKeyQ
                            }
                          )

      if ( newTx === null ) {
        alert("Tester APP testPotentialOffer() FAILED claimAndPublishFunc() of " + domainToSetOffer)
        return
      }

      console.warn("We THINK we managed to set an offer for  domain " + domainToSetOffer)
      console.warn("  let's look at txid of : " + newTx)


      const newQDtx = await queryFetchDecodeTx(window.shizzleContext, newTx, db, true)
      console.error("EXAMINE successful set of OFFER. newQDtx (note the outputStates[0].ownerCount, and QC): ", newQDtx)

      if ( newQDtx.outputStates[0].priceInSatsDecimal !== offerPrice ) {
        alert("SOMETHING WENT WRONG with setting the potential offer. EXAMINE the decoded tx.")
        return
      }

      alert("Success at setting offer ! (check console for price")







    } finally {
      this.updateWalletSummary
    }
  }

  async testPotentialBuy() {

    await this.maybeInitializeFundingParams()

    try {
      alert("IMPLEMENT testPotentialBUY")
    } finally {
      this.updateWalletSummary
    }
  }

  async testAvatarPromotion() {

    await this.maybeInitializeFundingParams()

    try {
      alert("IMPLEMENT testAvatarPromotion")
    } finally {
      this.updateWalletSummary
    }
  }

  scannerFeedback(mostRecentDomain, numNodes) {
    this.setState({ mostRecentDomain: mostRecentDomain,
                    numNodes:         numNodes
    })
  }

  render() {

    // ***  DEVICE-DEPENDENT STYLING  ***
    // For mobile, "detect" landscape screen mode
    const landscape = this.props.isMobile ? window.innerWidth > window.innerHeight : false
    // For mobile, shrink the About, Security, and Glossary modals
    const modalClassName   = this.props.isMobile ?
                                    (landscape ?
                                            "modalMobileLandscape"
                                        :
                                            "modalMobilePortrait"
                                    )
                                :
                                    ""
    const modalContentClassName = this.props.isMobile ? "modalContentMobile" : ""
    const modalBottomClassName  = this.props.isMobile ? "modalBottomMobile"  : ""

/*
console.warn("\nbundle: ", this.props.bundle)
console.warn("balancePennies: ", this.props.balancePennies)
console.warn("bsvPriceUSD: ", this.props.bsvPriceUSD)
console.error("state.privK: " + this.state.privK)
console.error("state.fundingAddress: " + this.state.fundingAddress)
*/
    const showOpenWalletButton =
          <>
            <Button style={{backgroundColor:'blue', color:'white'}} onClick={() => this.props.handleSignInOutClick(this.props.parent)}>OPEN Wallet</Button>
          </>

    const walletStuff = <>
                <br></br>
                <Button onClick={this.handleWalletClick}>Your Wallet</Button>
                &nbsp; &nbsp; &nbsp;
                <Button onClick={this.closeWallet}>Close Wallet</Button>
                <br></br>
                { this.state.walletInitialized ?
                        <>
                          &nbsp; &nbsp; available Builder Payout Keys: {this.state.freeP2PKHsCount}
                          &nbsp; &nbsp; available Publisher Keys: {this.state.freeRabinsCount}
                        </>
                      :
                        <>
                        </>
                }
    </>

    const testMenuToDisplay = this.state.showBlockHeightTests ?
          <>
            <div style={{textAlign: 'center'}}>

              <Button style={{backgroundColor: 'purple', color:'yellow'}} onClick={() => this.scanOldDomains()}>
                Scan ALL 'OLD' domains - to prep for tests
              </Button>
              <br></br><br></br>

              <Button style={{backgroundColor: 'blue', color:'white'}} onClick={() => this.claimAndPost(null, null, null, true, true)}>
                CLAIM and POST - with OLD BLOCKHEIGHTs
              </Button>
              <br></br><br></br>

              <Button style={{backgroundColor: 'blue', color:'white'}} onClick={() => this.claimMultipleRandomDomains(  null, null, 3, null, console.warn, true, true  )}>
                  Claim MULTIPLE random domains - with OLD BLOCKHEIGHTs
              </Button>
              <br></br><br></br>

              <Button  positive style={{color:'yellow'}} onClick={this.measureSlackOfOldDomains}>
                SCAN 'old' domains to measure their blockHeight 'SLACK'
              </Button>
              <br></br><br></br>

              <Button  positive style={{backgroundColor: 'black', color:'yellow'}} onClick={this.testRenewal}>
                Test RENEWING
              </Button>
              <br></br><br></br>

              &nbsp; &nbsp;
              <Button  positive style={{backgroundColor: 'black', color:'yellow'}} onClick={this.testInstaOffer}>
                Test Insta-OFFER
              </Button>
              <br></br><br></br>

              <Button  positive style={{backgroundColor: 'black', color:'yellow'}} onClick={this.testInstaBuy}>
                Test Insta-BUYING
              </Button>
              <br></br><br></br>


              &nbsp; &nbsp;
              <Button  positive style={{backgroundColor: 'black', color:'yellow'}} onClick={this.testBuildNextQuarterly}>
                Test build next QUARTERLY
              </Button>
              <br></br><br></br>

              <Button  positive style={{backgroundColor: 'black', color:'yellow'}} onClick={this.testReclaiming}>
                Test RE-CLAIMING
              </Button>
              <br></br><br></br>

              <Button  positive style={{backgroundColor: 'yellow', color:'black'}} onClick={this.testBuildNextPeriodical}>
                Test build next PERIODICAL (Updates)
              </Button>
              <br></br><br></br>

              <Button  positive style={{backgroundColor: 'orange', color:'black'}} onClick={this.testPotentialOffer}>
                Test POTENTIAL-OFFER (specify potential buyer rabin, price, deadline)
              </Button>
              <br></br><br></br>

              <Button  positive style={{backgroundColor: 'orange', color:'black'}} onClick={this.testPotentialBuy}>
                Test POTENTIAL-BUY (gen authcode, and APPLY it to fulfill offer)
              </Button>
              <br></br><br></br>

              <Button  positive style={{color:'yellow'}} onClick={this.testSpoofReclaim}>
                Test SPOOFING blockheight to re-claim a QUARTERLY
              </Button>
              <br></br><br></br>

              <Button  positive style={{color:'yellow'}} onClick={this.testOverridedSpoofedReclaim}>
                Test OVERRIDING a SPOOFED re-claim of a QUARTERLY
              </Button>
              <br></br><br></br>

              <Button  positive style={{backgroundColor: 'purple', color:'yellow'}} onClick={this.testSpoofReclaim}>
                Test SPOOFING blockheight for Periodical, or Transient (regular post, or guest-post)
              </Button>
              <br></br><br></br>

              <Button  positive style={{backgroundColor: 'purple', color:'yellow'}} onClick={this.testAvatarPromotion}>
                Test AVATAR, and other promotion-related scenarios
              </Button>
              <br></br><br></br>

              <Button  negative style={{color:'yellow'}} onClick={this.showNormalTests}>
                BACK to other tests
              </Button>
            </div>
          </>
        :
          this.state.showMigrationOptions ?
                <>
                  <div style={{textAlign: 'center'}}>
                    <Button  positive style={{backgroundColor: 'purple', color:'yellow'}} onClick={() => scanAllDomains( window.shizzleContext, this.scannerFeedback )}>
                      Scan the ShizzleVerse. Save to IDB.
                    </Button>
                    <br></br><br></br>

                    <Button  positive style={{backgroundColor: 'blue', color:'yellow'}} onClick={this.publishMigrationNodes}>
                      PUBLISH MigrationNodesArray to the blockchain
                    </Button>
                    <br></br><br></br>

                    <Button  positive style={{backgroundColor: 'blue', color:'yellow'}} onClick={this.readMigrationDataFromBlockchain}>
                      READ and DIGEST MigrationNodesArray from the blockchain
                    </Button>
                    <br></br><br></br>

                    <Button  positive style={{backgroundColor: 'purple', color:'yellow'}} onClick={this.processRegisteredNodes}>
                      Read and process IDB-SAVED nodes of ShizzleTree
                    </Button>
                    <br></br><br></br>

                    <Button  positive style={{backgroundColor: 'purple', color:'yellow'}} onClick={this.showMerkleTool}>
                      Generate a Merkle Proof for a given node/domain
                    </Button>
                    <br></br><br></br>

                    <Button  negative style={{color:'yellow'}} onClick={this.showNormalTests}>
                      BACK to basic tests
                    </Button>
                    <br></br>
                    numNodes: {this.state.numNodes}<br></br>
                    mostRecentDomain: {this.state.mostRecentDomain}
                  </div>
                </>
              :
                <>
                  <div style={{textAlign: 'center'}}>

                      <Button  style={{color:'grey'}}  onClick={this.buildFirstBuilderPrep} disabled>
                        Create FIRST builderPrep (BEFORE a genesis)
                      </Button>
                      <br></br>
                      <br></br>
                      <Button  positive  onClick={this.buildRootAppend}>
                        Create the ROOT Append (BEFORE fan-out)
                      </Button>
                      <br></br><br></br>

                      <Button negative  onClick={this.buildFanout}>
                        Create the GENESIS tx (follow-on fan-out) from a ROOT Append
                      </Button>
                      <br></br><br></br>

                      <Button  positive  onClick={this.buildDialogForTesting}>
                        CLONE a Dialog tx - for testing
                      </Button>
                      <br></br><br></br>

                      <Button style={{backgroundColor: 'blue', color:'white'}} onClick={this.claimSingleDomain}>
                        CLAIM a domain
                      </Button>
                      <br></br><br></br>

                      <Button style={{backgroundColor: 'blue', color:'white'}} onClick={this.claimMultipleRandomDomains}>
                        Claim MULTIPLE random domains
                      </Button>
                      <br></br><br></br>

                      <Button style={{backgroundColor: 'purple', color:'white'}} onClick={this.claimAndPost}>
                        CLAIM and POST
                      </Button>
                      <br></br><br></br>

                      <Button style={{backgroundColor: 'purple', color:'white'}} onClick={()=>this.startATest('seek-then-post', this.kickOffPostToDomainWeAlreadyOwn) /*this.seekThenPost*/}>
                        <span style={{color:'yellow'}}>KO:</span> POST to domain we ALREADY own. BUT IMPROVE THIS: it's hardcoded from 'something' to 'bilbo'
                      </Button>
                      <br></br><br></br>

                      <Button style={{backgroundColor: 'purple', color:'white'}} onClick={this.seekThenGuestPost}>
                        GUEST post FROM domain we ALREADY own
                      </Button>
                      <br></br><br></br>

                      <Button style={{backgroundColor: 'purple', color:'white'}} onClick={() => this.seekThenGuestPost(null, null, 'bilbo', 'somedomain', 4)}>
                        GUEST post 4 times from <span style={{color:'yellow'}}>BILBO to SOMEDOMAIN</span>
                      </Button>
                      <br></br><br></br>

                      <Button style={{backgroundColor: 'purple', color:'white'}} onClick={()=>this.startATest('multi-step-GEN-test', this.kickOffMultiStepGenTest)}>
                      <span style={{color:'yellow'}}>KO:</span> MULTI-STEP test to <span style={{color:'orange'}}>GENERATE</span> names, claim them, guest-post MULTIPLE times, randomly
                      </Button>
                      <br></br><br></br>

                      <Button style={{backgroundColor: 'purple', color:'white'}} onClick={()=>this.startATest('multi-step-PICK-test', this.kickOffMultiStepPickTest)}>
                      <span style={{color:'yellow'}}>KO:</span> MULTI-STEP test to <span style={{color:'orange'}}>PICK</span> domains, guest-post MULTIPLE times, randomly
                      </Button>
                      <br></br><br></br>

                      <Button negative style={{color:'yellow'}} onClick={this.handleEraseEverythingClick}>
                        Clear IDB
                      </Button>
                      <br></br><br></br>

                      <Button style={{backgroundColor: 'black', color:'yellow'}} onClick={this.showBlockHeightRelatedTests}>
                        Run BLOCKHEIGHT-related tests: RENEWING, SELLING/BUYING, RE-CLAIMING, etc
                      </Button>

                      <br></br><br></br>

                      <Button style={{backgroundColor: 'black', color:'yellow'}} onClick={this.showMigrationRelatedOptions}>
                        Run ADMIN operations for MIGRATION: restoring builders and owners
                      </Button>

                  </div>
                </>

    const maybeQuickToast = this.state.showQuickToast ?
            <>
            <Toast  durationMillis={this.state.toastDuration}
                displayText={this.state.toastText}
                noLoader={this.state.suppressLoader}
                done={this.quickToastDone}
                parent={this}/>
            </>
        :
            <></>

    // NOTE: the pop-up explainer icon has absolute position:
    //       see: https://stackoverflow.com/questions/16236142/two-divs-on-same-position
    return (
      <>
      <div>
        <br></br>
            
        <b>TESTER APP</b> - for exercising of contract, and harness code
        <br></br>
        <br></br>
        { typeof this.props.bundle == 'undefined' || this.props.bundle === null ?
              showOpenWalletButton
                :
              <>
                {testMenuToDisplay}
                {walletStuff}
              </>
        }
      </div>

      {maybeQuickToast}

      <ProgressListModal  openProgressList={this.state.openTheProgressList}
                          fleeting={false}
                          domain={null}
                          ourWorkToDo={this.state.whichTestFuncForPLMToCall}
                          onCancel={this.aTestWasCanceled}
                          onDone={this.closeProgressList}
                          title={this.state.nameOfTest}
                          description="Now running test..."/>

      <Modal size='small' centered className={modalClassName}  open={this.state.showMerkleModal} style={{backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
          <Modal.Header style={{textAlign: 'center', backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
              <span style={{color: this.bshzYellow}}> Erase EVERYTHING - Full Reset </span>
          </Modal.Header>
          <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: this.bshzLtPurp}}>

            Merkle Migration Tool
            <br></br>
            <br></br>
            <Button positive onClick={this.generateMerkleProof}>
              Generate a Merkle Proof
            </Button>
          </Modal.Content>
          <Modal.Actions className={modalBottomClassName} style={{backgroundColor: this.bshzPurple, borderRadius: '0px 0px 20px 20px'}}>
              <div style={{textAlign: 'center'}}>
                  <Button negative onClick={this.closeMerkleTool} content='Done/Cancel'/>
              </div>
          </Modal.Actions>
      </Modal>

      <Modal size='small' centered className={modalClassName}  open={this.state.showResetModal} style={{backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
          <Modal.Header style={{textAlign: 'center', backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
              <span style={{color: this.bshzYellow}}> Erase EVERYTHING - Full Reset </span>
          </Modal.Header>
          <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: this.bshzLtPurp}}>

              <p></p>
                  <span style={{color: "red", fontSize: "2rem"}}>
                      Are you <b>sure</b>?
                  </span>
              <p></p>

              Are you <b>sure</b> you want to erase EVERYTHING from {this.bitShizzle} - including any wallet? If you haven't already backed it up,
              you'll <b style={{color: "red"}}>never</b> be able to restore it, and spend the coins it contains, nor use any domains/assets you've claimed.

          </Modal.Content>
          <Modal.Actions className={modalBottomClassName} style={{backgroundColor: this.bshzPurple, borderRadius: '0px 0px 20px 20px'}}>
              <div style={{textAlign: 'center'}}>
                  <Button negative onClick={this.closeFullReset} content='Never Mind'/>
                  <Button negative onClick={this.performFullReset} content='I Understand. Delete EVERYTHING.'/>
              </div>
          </Modal.Actions>
      </Modal>
      </>
          )
  }
}

export default TesterApp;
